var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-scan-to-pay",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes lightSpeedRight{60%{transform:skewX(10deg);opacity:1}80%{transform:skewX(-2deg)}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes lightSpeedLeft{60%{transform:skewX(-10deg);opacity:1}80%{transform:skewX(2deg)}}svg#freepik_stories-scan-to-pay:not(.animated) .animable{opacity:0}svg#freepik_stories-scan-to-pay.animated #freepik--speech-bubble--inject-4{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight;animation-delay:0s}")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4",
    style: {
      transformOrigin: "251.004px 348.79px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-4",
    d: "M82 446.35c-93.33-53.88-93.33-141.24 0-195.12s244.65-53.89 338 0 93.33 141.24 0 195.12-244.66 53.89-338 0z",
    style: {
      fill: "#fafafa",
      transformOrigin: "251.004px 348.79px 0"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-4",
    style: {
      transformOrigin: "375.005px 80.675px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-4",
    style: {
      transformOrigin: "375.005px 106.305px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-4",
    style: {
      transformOrigin: "375.005px 106.305px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "374.995px 122.465px 0"
    },
    id: "elyevtr3vfngm",
    className: "animable",
    d: "m391.1 130.89-1.5.89-30.71-17.73 1.49-.9 30.72 17.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "374.99px 106.295px 0"
    },
    id: "elcfzg81n4hog",
    className: "animable",
    d: "m360.38 113.15 29.22 16.87v-30.6l-29.22-16.85v30.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.06 115.68 36.37 21V97.79l-36.37-21zm2.83-34 30.71 17.74v32.36l-30.71-17.73z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "374.245px 106.735px 0"
    },
    id: "el29b9gwhy194",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "359.635px 97.87px 0"
    },
    id: "eln6yt3w1own",
    className: "animable",
    d: "m358.89 114.05 1.49-.9V82.57l-1.49-.88v32.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "375.005px 86.86px 0"
    },
    id: "elebdcvywk69t",
    className: "animable",
    d: "m356.06 76.8 1.52-.87 36.37 20.99-1.52.87-36.37-20.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.19px 116.795px 0"
    },
    id: "elko6sb844v6s",
    className: "animable",
    d: "m393.95 96.92-1.52.87v38.88l1.52-.87V96.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-4",
    style: {
      transformOrigin: "374.99px 111.385px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "374.99px 111.385px 0"
    },
    id: "elwao5r73esy",
    className: "animable",
    d: "m361.52 112.24 26.94 15.55v-7.77l-6.73-15.56-4.2 3.89 1.51 6.52-9.3-19.89-8.22 9.48v7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.78 97a4.39 4.39 0 0 1 2 3.45c0 1.28-.9 1.79-2 1.16a4.41 4.41 0 0 1-2-3.46c.01-1.32.9-1.83 2-1.15z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "377.78px 99.2893px 0"
    },
    id: "elrs3wk6epcu",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-4",
    style: {
      transformOrigin: "375.005px 55.045px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-4",
    style: {
      transformOrigin: "375.005px 55.045px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "374.995px 71.21px 0"
    },
    id: "el6aczmz991m",
    className: "animable",
    d: "m391.1 79.63-1.5.89-30.71-17.73 1.49-.89 30.72 17.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "374.99px 55.035px 0"
    },
    id: "els5y4gvssyiq",
    className: "animable",
    d: "m360.38 61.9 29.22 16.86v-30.6l-29.22-16.85V61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.06 64.42 36.37 21V46.53l-36.37-21zm2.83-34 30.71 17.74v32.36l-30.71-17.73z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "374.245px 55.475px 0"
    },
    id: "elb0oj8d61r1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "359.635px 46.61px 0"
    },
    id: "elsjp34o76rr",
    className: "animable",
    d: "m358.89 62.79 1.49-.89V31.31l-1.49-.88v32.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "375.005px 35.6px 0"
    },
    id: "elena0jgsklu4",
    className: "animable",
    d: "m356.06 25.54 1.52-.87 36.37 20.99-1.52.87-36.37-20.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "393.19px 65.535px 0"
    },
    id: "elx47uy1tolln",
    className: "animable",
    d: "m393.95 45.66-1.52.87v38.88l1.52-.87V45.66z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-4",
    style: {
      transformOrigin: "374.99px 60.125px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "374.99px 60.125px 0"
    },
    id: "elj0s6lmhoogl",
    className: "animable",
    d: "m361.52 60.98 26.94 15.55v-7.77l-6.73-15.56-4.2 3.89 1.51 6.52-9.3-19.89-8.22 9.48v7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.78 45.7a4.38 4.38 0 0 1 2 3.45c0 1.27-.89 1.78-2 1.15a4.41 4.41 0 0 1-2-3.45c.01-1.27.9-1.79 2-1.15z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "377.78px 47.9978px 0"
    },
    id: "elaztwkasd9ze",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4",
    style: {
      transformOrigin: "442.055px 127.885px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-4",
    style: {
      transformOrigin: "442.055px 127.885px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-4",
    style: {
      transformOrigin: "442.055px 127.885px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-4",
    style: {
      transformOrigin: "442.055px 127.885px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "442.04px 203.215px 0"
    },
    id: "elzafndx427s",
    className: "animable",
    d: "m477.01 222.2-2.05 1.23-67.89-39.2 2.05-1.23 67.89 39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "442.04px 127.88px 0"
    },
    id: "elv5zenfgj8p",
    className: "animable",
    d: "m409.12 183 65.84 38.01V72.74l-65.84-37.99V183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.18 186.47 75.66 43.68V70.5l-75.66-43.68zm3.89-152.93L475 72.74v150.69l-67.89-39.2z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "441.01px 128.485px 0"
    },
    id: "ells8ws31qxoc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "408.095px 108.885px 0"
    },
    id: "elp32v9yyvno",
    className: "animable",
    d: "m407.07 184.23 2.05-1.23V34.75l-2.05-1.21v150.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "441.015px 155.09px 0"
    },
    id: "elhczw0sv4k0i",
    className: "animable",
    d: "M474.96 172.88v2.42l-67.89-39.2 2.05-1.22 65.84 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "441.015px 96.19px 0"
    },
    id: "elmumd9nfts4c",
    className: "animable",
    d: "M474.96 113.99v2.41l-67.89-39.2 2.05-1.22 65.84 38.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "442.055px 48.06px 0"
    },
    id: "elx0x3qgyl12",
    className: "animable",
    d: "m403.18 26.82 2.09-1.2 75.66 43.68-2.09 1.2-75.66-43.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "479.885px 149.725px 0"
    },
    id: "elg4e63hy86yp",
    className: "animable",
    d: "m480.93 69.3-2.09 1.2v159.65l2.09-1.19V69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "443.985px 129.605px 0"
    },
    id: "elthd2jafc94",
    className: "animable",
    d: "m445.03 55.46-2.09-1.2v150.69l2.09-1.19V55.46z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "441px 128.49px 0"
    },
    id: "el9rpb03wm1aw",
    className: "animable",
    d: "m439.06 52.03 3.88 2.23v150.69l-3.88-2.24V52.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "441.01px 99.04px 0"
    },
    id: "ele4trduegirh",
    className: "animable",
    d: "M403.18 74.96v4.48l75.66 43.68v-4.48l-75.66-43.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "441.01px 157.93px 0"
    },
    id: "ellq6qhwt6bze",
    className: "animable",
    d: "M403.18 133.85v4.48l75.66 43.68v-4.48l-75.66-43.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "458.95px 106.555px 0"
    },
    id: "el6cxnjdhzalx",
    className: "animable",
    d: "m442.94 97.92 2.09-1.21 29.93 17.28v2.41l-32.02-18.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "458.95px 165.43px 0"
    },
    id: "elavnesjx1c9b",
    className: "animable",
    d: "m442.94 156.79 2.09-1.21 29.93 17.28v2.42l-32.02-18.49z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-4",
    style: {
      transformOrigin: "78.765px 76.15px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-4",
    style: {
      transformOrigin: "78.765px 76.15px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "78.5px 90.28px 0"
    },
    id: "elmux2b5jllyo",
    className: "animable",
    d: "m136.74 71.19-27.8-16.05-88.68 51.18v3.05l27.8 16.05 88.68-51.17v-3.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "78.5px 88.755px 0"
    },
    id: "elstjkf6q5j4n",
    className: "animable",
    d: "m48.06 122.37 88.68-51.18-27.8-16.05-88.68 51.18 27.8 16.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      transformOrigin: "34.16px 115.87px 0"
    },
    id: "el10kj9ce6dwfm",
    className: "animable",
    d: "M48.06 122.37v3.05l-27.8-16.05v-3.05l27.8 16.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "119.435px 49.655px 0"
    },
    id: "el684cmz2qap",
    className: "animable",
    d: "m110.42 27.3 18.03 10.41v34.3L110.42 61.6V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.87 38.28-17.45-10a7.35 7.35 0 0 1-4 2.18l17.3 10a17.34 17.34 0 0 0 4.15-2.18z",
    style: {
      fill: "#fff",
      transformOrigin: "117.145px 34.37px 0"
    },
    id: "el60kecawdxnv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.05 40.36a3.75 3.75 0 0 0 3.36 0l2.94-1.69a1 1 0 0 0 0-1.92l-17.2-9.87-.73.42 16.91 9.76a.61.61 0 0 1 0 1.16l-2.73 1.55a2.22 2.22 0 0 1-2 0L105.68 30l-.82.47z",
    style: {
      fill: "#fafafa",
      transformOrigin: "116.965px 33.8187px 0"
    },
    id: "el4u24uq0gm8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.86 30.49v34.3l17.19 9.87a3.75 3.75 0 0 0 3.36 0l2.94-1.66a1.17 1.17 0 0 0 .69-1V37.71a1.16 1.16 0 0 1-.69 1l-2.94 1.69a3.75 3.75 0 0 1-3.36 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "116.95px 52.7737px 0"
    },
    id: "elu1rxb67b5ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.73 40.76a3.42 3.42 0 0 0 1.68-.4l2.94-1.69a1.16 1.16 0 0 0 .69-1V72a1.17 1.17 0 0 1-.69 1l-2.94 1.69a3.53 3.53 0 0 1-1.68.39z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "126.385px 56.3753px 0"
    },
    id: "elbrwsjm95pej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "112.065px 53.885px 0"
    },
    id: "el8jvihlwqmgy",
    className: "animable",
    d: "m103.05 31.53 18.03 10.41v34.3l-18.03-10.41v-34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.5 42.51-17.45-10a7.35 7.35 0 0 1-4 2.18l17.3 10a17.34 17.34 0 0 0 4.15-2.18z",
    style: {
      fill: "#fff",
      transformOrigin: "109.775px 38.6px 0"
    },
    id: "elf2yvauflbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.68 44.59a3.73 3.73 0 0 0 3.35 0l2.97-1.68c.93-.54.93-1.4 0-1.93l-17.19-9.87-.73.42L120 41.3c.56.32.56.83 0 1.15L117.23 44a2.22 2.22 0 0 1-2 0l-16.92-9.75-.82.47z",
    style: {
      fill: "#fafafa",
      transformOrigin: "109.594px 38.0486px 0"
    },
    id: "elg15iiw7jy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49 34.72V69l17.19 9.87a3.73 3.73 0 0 0 3.35 0L121 77.2a1.17 1.17 0 0 0 .7-1V41.94a1.17 1.17 0 0 1-.7 1l-3 1.65a3.73 3.73 0 0 1-3.35 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "109.595px 56.9936px 0"
    },
    id: "el4latkmanxmw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.36 45a3.36 3.36 0 0 0 1.67-.4l2.97-1.7a1.17 1.17 0 0 0 .7-1v34.3a1.17 1.17 0 0 1-.7 1l-3 1.69a3.46 3.46 0 0 1-1.67.4z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "119.015px 60.5952px 0"
    },
    id: "el9eyo1ee55h7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "96.955px 63.515px 0"
    },
    id: "elv9zhhkk2fy",
    className: "animable",
    d: "m90.74 40.64 18.03 10.42-5.6 35.33-18.03-10.41 5.6-35.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.05 51.55-17.45-10a9.6 9.6 0 0 1-4.6 1.79l17.31 10a23.36 23.36 0 0 0 4.74-1.79z",
    style: {
      fill: "#fff",
      transformOrigin: "97.025px 47.445px 0"
    },
    id: "elrwky5vd1usc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.45 53.17a4.69 4.69 0 0 0 3.63.17l3.43-1.41c1.08-.44 1.21-1.23.28-1.76l-17.2-9.87-.85.34 16.91 9.77c.56.32.48.79-.17 1.06l-3.19 1.28a2.83 2.83 0 0 1-2.18-.09l-16.9-9.75-1 .39z",
    style: {
      fill: "#fafafa",
      transformOrigin: "96.8108px 46.963px 0"
    },
    id: "elxvujy9sjmtm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.24 43.3-5.6 35.33 17.21 9.88a4.69 4.69 0 0 0 3.63.16l3.43-1.4c.54-.22.84-.53.9-.85l5.6-35.33c-.06.32-.36.62-.9.84l-3.43 1.41a4.65 4.65 0 0 1-3.63-.17z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "94.025px 66.1302px 0"
    },
    id: "elcvf4g43pqqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.21 53.62a4.57 4.57 0 0 0 1.87-.28l3.43-1.41c.54-.22.84-.52.9-.84l-5.6 35.33c-.06.32-.36.63-.9.85l-3.43 1.4a4.57 4.57 0 0 1-1.87.28z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "103.51px 70.0241px 0"
    },
    id: "elpyf1ei96qj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-4",
    style: {
      transformOrigin: "71.54px 80.85px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-4",
    style: {
      transformOrigin: "71.54px 80.85px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "73.245px 98.305px 0"
    },
    id: "elnevq8pp1ydj",
    className: "animable",
    d: "m60.78 104.83 1.28.61 23.65-13.65-1.27-.62-23.66 13.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "71.55px 80.84px 0"
    },
    id: "eljkebf2np6dl",
    className: "animable",
    d: "m84.44 91.17-22.51 12.99-3.27-33.66 22.5-12.98 3.28 33.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.26 53.22-28 16.16 3.86 39.7 28-16.17zm1.45 38.57-23.65 13.66-3.4-34.94 23.65-13.66z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "72.19px 81.15px 0"
    },
    id: "el1ke0satjxqf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "83.435px 74.32px 0"
    },
    id: "elnif3mducl6c",
    className: "animable",
    d: "m85.71 91.79-1.27-.62-3.28-33.65 1.15-.67 3.4 34.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "69.61px 61px 0"
    },
    id: "elb2cjwj3w9kh",
    className: "animable",
    d: "m84.26 53.22-1.3-.6-28 16.16 1.29.6 28.01-16.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "57.54px 88.93px 0"
    },
    id: "elkvyjzersc4p",
    className: "animable",
    d: "m54.96 68.78 1.29.6 3.87 39.7-1.3-.6-3.86-39.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-4",
    style: {
      transformOrigin: "72.795px 87.727px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      transformOrigin: "72.795px 87.745px 0"
    },
    id: "eldv1514oe0x",
    className: "animable",
    d: "M83.44 90.53 62.7 102.51l-.55-5.67 3.86-16.66 3.68 5.69-.77 4.79 6.14-17.68 7.83 11.88.55 5.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.69 73.17a2.92 2.92 0 0 0-1.37 2.56c.09.93.85 1.29 1.7.8A2.94 2.94 0 0 0 67.39 74c-.09-1-.85-1.32-1.7-.83z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "65.8546px 74.8465px 0"
    },
    id: "elfinayzjwcn",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-4",
    style: {
      transformOrigin: "42.1862px 96.6592px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.13 102.49c3.84 2.22 3.84 5.81 0 8a15.4 15.4 0 0 1-13.9 0c-3.84-2.22-3.84-5.81 0-8a15.4 15.4 0 0 1 13.9 0z",
    style: {
      opacity: 0.05,
      transformOrigin: "42.18px 106.49px 0"
    },
    className: "animable",
    id: "freepik--Shadow--inject-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.93 108.08c-3.34-3.41-5.3-11.92-2-14.63h16.54c3.26 2.71 1.3 11.22-2 14.63l-.09.09-.12.12a2.55 2.55 0 0 1-.3.26.27.27 0 0 1-.08.07l-.25.19a5.08 5.08 0 0 1-.43.27 11 11 0 0 1-10 0 5.08 5.08 0 0 1-.43-.27l-.24-.18-.1-.08-.29-.26-.13-.13a.6.6 0 0 1-.08-.08z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "42.1862px 101.866px 0"
    },
    id: "elyjovrqkn2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 92.15c3.79 2.19 3.79 5.73 0 7.92a15.17 15.17 0 0 1-13.7 0c-3.79-2.19-3.79-5.73 0-7.92a15.17 15.17 0 0 1 13.7 0z",
    style: {
      fill: "#fff",
      transformOrigin: "42.15px 96.11px 0"
    },
    id: "elfhcqc1v7dwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35 93.7c2.3 1.33 2.3 3.49 0 4.82a9.21 9.21 0 0 1-8.34 0c-2.3-1.33-2.3-3.49 0-4.82a9.21 9.21 0 0 1 8.34 0z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "42.18px 96.11px 0"
    },
    id: "el76no73nbzwt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 96a9.21 9.21 0 0 1 8.34 0 3.88 3.88 0 0 1 1.38 1.26 3.9 3.9 0 0 1-1.38 1.27 9.21 9.21 0 0 1-8.34 0 3.9 3.9 0 0 1-1.38-1.27A3.88 3.88 0 0 1 38 96z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "42.17px 97.265px 0"
    },
    id: "elxpws80tvn1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.84 97.25a18.91 18.91 0 0 0 3-4c1.39-2.46 1.65-5.76.93-6.17S46.14 90 46.14 90a17.7 17.7 0 0 0 .3-4.21c-.12-2.19-.65-4.18-1.28-4.58s-2 2.36-2.64 4.37-1 3.65-1 3.65a30.75 30.75 0 0 0-1.08-4.61c-.73-2.09-1.39-2.56-1.91-2.35s-.85 1.18-1 4a27.07 27.07 0 0 0 .12 4s-1-1.14-2.18-2.24-1.8-1.38-2.16-1.15-.46 2.12 1.49 5.65a19.8 19.8 0 0 0 3.69 4.84s2.74 1.63 7.35-.12z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "41.6312px 89.6156px 0"
    },
    id: "elauxzl9s1awd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tag--inject-4",
    style: {
      transformOrigin: "132.86px 93.675px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.59 82.74v20l8.54-4.94v-20zm4.26 1c-.46.27-.84 0-.84-.5a1.89 1.89 0 0 1 .84-1.46c.47-.27.85-.06.85.48a1.88 1.88 0 0 1-.85 1.43z",
    style: {
      fill: "#fafafa",
      transformOrigin: "132.86px 90.27px 0"
    },
    id: "elaa287skz86a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 78v19.76l-8.27 4.77V82.81L137 78m.27-.47-8.81 5.08V103l8.81-5.08V77.57z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.865px 90.265px 0"
    },
    id: "elsgwiuuldvkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.855px 105.55px 0"
    },
    id: "el24xqm9leps4",
    className: "animable",
    d: "M137.26 97.92v10.17l-8.81 5.09V103l8.81-5.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 90.66a.27.27 0 0 1-.24-.14.28.28 0 0 1 .1-.37l5.76-3.32a.27.27 0 1 1 .27.47l-5.76 3.32a.22.22 0 0 1-.13.04z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.877px 88.727px 0"
    },
    id: "eli1opr47ptgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 92.32a.27.27 0 0 1-.24-.14.28.28 0 0 1 .1-.37l5.76-3.32a.28.28 0 0 1 .37.1.27.27 0 0 1-.1.37l-5.76 3.32a.22.22 0 0 1-.13.04z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.877px 90.3885px 0"
    },
    id: "elneybd5v7afi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 94a.28.28 0 0 1-.24-.13.27.27 0 0 1 .1-.37l5.76-3.33a.28.28 0 0 1 .37.1.27.27 0 0 1-.1.37L130.11 94a.31.31 0 0 1-.11 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.875px 92.071px 0"
    },
    id: "elny17adneaj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 95.64a.26.26 0 0 1-.24-.13.27.27 0 0 1 .1-.37l5.76-3.33a.28.28 0 0 1 .37.1.27.27 0 0 1-.1.37l-5.76 3.33a.31.31 0 0 1-.13.03z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.875px 93.7087px 0"
    },
    id: "el1bynsfcv6x2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.86 83a.28.28 0 0 1-.28-.27v-8.29a.28.28 0 0 1 .28-.27.27.27 0 0 1 .27.27v8.27a.28.28 0 0 1-.27.29z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "132.855px 78.585px 0"
    },
    id: "elazup9owka6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68 103.74c-.12-.24-.46-.28-.77-.09a1.3 1.3 0 0 0-.73 1.08c0 .47.36.34.74.19.68-.26 1.39-.49 1.39.76a2.73 2.73 0 0 1-1.09 2.18v.71l-.58.33v-.67a.79.79 0 0 1-1.21-.51l.55-.67c.12.38.53.44.91.22a1.49 1.49 0 0 0 .79-1.23c0-.47-.38-.42-.81-.25-.65.27-1.29.46-1.29-.71a2.63 2.63 0 0 1 1.06-2.06v-.62l.58-.34v.62a.67.67 0 0 1 1 .42z",
    style: {
      fill: "#fff",
      transformOrigin: "132.87px 105.48px 0"
    },
    id: "elx5zpgl1tx6o",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4",
    style: {
      transformOrigin: "244.9px 341.182px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-4",
    style: {
      transformOrigin: "462.19px 340.157px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.3 379.9h-.17l-4.9-1.26a.45.45 0 0 1-.3-.27c0-.13-4.3-12.88 4.78-30.17 6.48-12.34 16.63-20.36 23.1-18.25a7.2 7.2 0 0 1 5 5.13 8.33 8.33 0 0 1-2.64 7.78c-.5.5-1.29 1.17-2.29 2-6.2 5.27-20.7 17.6-22.27 34.65a.4.4 0 0 1-.17.3.48.48 0 0 1-.14.09zm-4.63-2 4.19 1.08c1.83-17.13 16.3-29.44 22.51-34.72 1-.84 1.77-1.51 2.25-2a7.49 7.49 0 0 0 2.4-7 6.31 6.31 0 0 0-4.48-4.52c-6.08-2-15.78 5.86-22.08 17.84-8.27 15.73-5.29 27.58-4.79 29.29z",
    style: {
      fill: "#f04e30",
      transformOrigin: "464.935px 354.757px 0"
    },
    id: "eltcl095597jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.51 379.18h-.05a.41.41 0 0 1-.43-.41c-.37-19.91 13.41-39.09 22.68-43a.43.43 0 0 1 .34.78c-9.17 3.91-22.52 23.37-22.18 42.24a.42.42 0 0 1-.36.39z",
    style: {
      fill: "#f04e30",
      transformOrigin: "462.638px 357.468px 0"
    },
    id: "eloeow10zz708",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.4 378.64a.41.41 0 0 1-.19 0l-3.32-1a.4.4 0 0 1-.28-.28c-.06-.19-5.92-19.21-1.6-44.83 2.2-13.05 9.8-25.78 18.09-30.27 4-2.15 7.89-2.43 11.63-.8a6.35 6.35 0 0 1 3.93 4c1.37 4.85-3.66 12.06-9 19.7-3.72 5.35-7.58 10.87-9.34 15.76a.42.42 0 1 1-.79-.29c1.79-5 5.68-10.56 9.44-15.95 5.21-7.47 10.13-14.53 8.87-19a5.48 5.48 0 0 0-3.46-3.48 11.93 11.93 0 0 0-10.89.77c-8.07 4.37-15.5 16.85-17.66 29.66-4 24 .89 42.08 1.51 44.23l3.11.93a.43.43 0 0 1 .28.53.45.45 0 0 1-.33.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "460.155px 339.532px 0"
    },
    id: "elwfpenh8i5ke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.57 366.52a.42.42 0 0 1-.45-.39c-2.51-30.8 14.67-55.45 19.76-59.68a.42.42 0 0 1 .59.05.43.43 0 0 1-.05.6c-5 4.17-21.94 28.5-19.46 59a.42.42 0 0 1-.39.42z",
    style: {
      fill: "#f04e30",
      transformOrigin: "458.22px 336.436px 0"
    },
    id: "elupnopthf1rb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-4",
    style: {
      transformOrigin: "27.6143px 342.181px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.34 381.83a.39.39 0 0 1-.18-.31c-1.57-17-16.07-29.37-22.26-34.64-1-.85-1.8-1.52-2.3-2a8.33 8.33 0 0 1-2.6-7.81 7.17 7.17 0 0 1 5-5.07c6.46-2.11 16.61 5.91 23.09 18.24 9.09 17.29 4.82 30.05 4.78 30.17a.41.41 0 0 1-.3.27l-4.89 1.26a.33.33 0 0 1-.17 0 .36.36 0 0 1-.17-.11zm0-31.24c-6.29-12-16-19.82-22.08-17.84a6.3 6.3 0 0 0-4.48 4.51 7.53 7.53 0 0 0 2.4 7c.49.47 1.27 1.13 2.25 2C19.66 351.52 34.12 363.82 36 381l4.19-1.08c.46-1.76 3.43-13.6-4.84-29.33z",
    style: {
      fill: "#f04e30",
      transformOrigin: "24.8739px 356.807px 0"
    },
    id: "el04fvf7y7epew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3 381.19h.06a.42.42 0 0 0 .43-.41c.36-19.91-13.42-39.09-22.69-43a.42.42 0 1 0-.33.78c9.16 3.9 22.51 23.36 22.17 42.24a.42.42 0 0 0 .36.39z",
    style: {
      fill: "#f04e30",
      transformOrigin: "27.1542px 359.468px 0"
    },
    id: "elf53vreuy2x9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.42 380.64a.37.37 0 0 0 .18 0l3.32-1a.41.41 0 0 0 .28-.28c.06-.19 5.92-19.21 1.6-44.83-2.19-13-9.8-25.78-18.08-30.27-4-2.16-7.9-2.43-11.64-.8a6.35 6.35 0 0 0-3.93 4c-1.37 4.84 3.66 12.06 9 19.7 3.73 5.34 7.58 10.87 9.34 15.75a.43.43 0 0 0 .54.26.42.42 0 0 0 .25-.54c-1.79-5-5.68-10.56-9.44-16-5.21-7.47-10.13-14.52-8.87-19a5.52 5.52 0 0 1 3.46-3.49 12 12 0 0 1 10.89.77c8.08 4.38 15.5 16.86 17.66 29.67 4 24-.89 42.08-1.51 44.22l-3.1.94a.43.43 0 0 0-.29.53.42.42 0 0 0 .34.37z",
    style: {
      fill: "#f04e30",
      transformOrigin: "29.6547px 341.531px 0"
    },
    id: "el038ecz743ak8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.24 368.53a.41.41 0 0 0 .45-.38c2.51-30.8-14.67-55.46-19.75-59.69a.43.43 0 0 0-.6.06.41.41 0 0 0 .05.59c5 4.17 21.94 28.51 19.46 59a.42.42 0 0 0 .39.42z",
    style: {
      fill: "#f04e30",
      transformOrigin: "31.5883px 338.449px 0"
    },
    id: "elwjlnnb7pvi",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-4",
    style: {
      transformOrigin: "253.285px 323.541px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-4",
    cx: 430.49,
    cy: 402.01,
    rx: 56.7,
    ry: 32.74,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "430.49px 402.01px 0"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-4",
    cx: 82.68,
    cy: 402.77,
    rx: 63.3,
    ry: 36.55,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "82.68px 402.77px 0"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "m252.63 306.35-44.51-25.71a.79.79 0 0 1 0-1.5L296 228.45a2.84 2.84 0 0 1 2.6 0l44.52 25.71a.8.8 0 0 1 0 1.51l-87.85 50.68a2.86 2.86 0 0 1-2.64 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "275.617px 267.404px 0"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "m180.12 300-63.68-36.77a.82.82 0 0 1 0-1.56l101.93-58.86a3 3 0 0 1 2.71 0l63.68 36.78a.82.82 0 0 1 0 1.56L182.82 300a2.93 2.93 0 0 1-2.7 0z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "200.6px 251.408px 0"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-4",
    d: "m123.77 343.75 98.94-57.12a8.69 8.69 0 0 1 7.85 0L395.81 382c2.17 1.25 2.17 3.28 0 4.53l-98.93 57.12a8.64 8.64 0 0 1-7.86 0l-165.25-95.4c-2.17-1.25-2.17-3.25 0-4.5z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "259.79px 365.144px 0"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bags--inject-4",
    style: {
      transformOrigin: "235.045px 170.555px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bag--inject-4",
    style: {
      transformOrigin: "205px 184.071px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.42 74.68c-3-1.75-6.77-1.53-10.5.63-8.6 5-15.59 19.31-15.59 32v29.88a1.36 1.36 0 1 0 2.71 0V107.3c0-11.81 6.39-25.11 14.24-29.64 2.9-1.67 5.59-1.89 7.78-.63 3.24 1.88 5.1 6.63 5.1 13v29.75a1.36 1.36 0 1 0 2.72 0V90.07c0-7.41-2.36-13.02-6.46-15.39z",
    style: {
      fill: "#263238",
      transformOrigin: "190.603px 106.089px 0"
    },
    id: "el17a1jarkgzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "247.09px 167.305px 0"
    },
    id: "elra1f2r9yq5k",
    className: "animable",
    d: "m267.18 246.03-8.37-143.66-23.96-13.79L227 222.83l40.18 23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "247.09px 167.305px 0"
    },
    className: "animable",
    d: "m267.18 246.03-8.37-143.66-23.96-13.79L227 222.83l40.18 23.2z",
    id: "elu6011nryj3q"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "188.835px 180.005px 0"
    },
    id: "el2zprqt560u",
    className: "animable",
    d: "m150.67 137.18-7.85 134.25 84.18-48.6 7.85-134.25-84.18 48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "188.835px 180.005px 0"
    },
    className: "animable",
    d: "m150.67 137.18-7.85 134.25 84.18-48.6 7.85-134.25-84.18 48.6z",
    id: "el7etmognydz6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05,
      transformOrigin: "188.835px 180.005px 0"
    },
    className: "animable",
    d: "m150.67 137.18-7.85 134.25 84.18-48.6 7.85-134.25-84.18 48.6z",
    id: "elkklpmswgi3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "162.91px 215.905px 0"
    },
    id: "elpp8ue58b1yr",
    className: "animable",
    d: "m150.67 137.18 23.96 13.79L183 294.63l-40.18-23.2 7.85-134.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.55,
      transformOrigin: "162.91px 215.905px 0"
    },
    className: "animable",
    d: "m150.67 137.18 23.96 13.79L183 294.63l-40.18-23.2 7.85-134.25z",
    id: "elrmu6lbc5i4i"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      opacity: 0.5,
      transformOrigin: "162.91px 240.17px 0"
    },
    className: "animable",
    d: "m183 294.63-17.27-24.25-2.16-84.67-2.16 83.2-18.59 2.52 40.18 23.2z",
    id: "elv7ygdqxfq8s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.81 102.37 174.63 151 183 294.63 267.18 246zm-59.11 52c-1.66.95-3 .16-3-1.76a6.65 6.65 0 0 1 3-5.21c1.66-1 3-.17 3 1.77a6.58 6.58 0 0 1-3 5.16zM229.53 137c-1.66.94-3 .15-3-1.77a6.63 6.63 0 0 1 3-5.2c1.66-1 3-.17 3 1.76a6.62 6.62 0 0 1-3 5.21z",
    style: {
      fill: "#f04e30",
      transformOrigin: "220.905px 198.5px 0"
    },
    id: "el0lnw5jclqfxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.81 102.37 174.63 151 183 294.63 267.18 246zm-59.11 52c-1.66.95-3 .16-3-1.76a6.65 6.65 0 0 1 3-5.21c1.66-1 3-.17 3 1.77a6.58 6.58 0 0 1-3 5.16zM229.53 137c-1.66.94-3 .15-3-1.77a6.63 6.63 0 0 1 3-5.2c1.66-1 3-.17 3 1.76a6.62 6.62 0 0 1-3 5.21z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "220.905px 198.5px 0"
    },
    className: "animable",
    id: "elywuxa0gnjng"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.43 88.34c-3-1.75-6.76-1.53-10.5.63-8.6 5-15.59 19.32-15.59 32v29.88a1.36 1.36 0 1 0 2.71 0V121c0-11.81 6.39-25.11 14.24-29.64 2.9-1.67 5.59-1.89 7.78-.62 3.24 1.87 5.1 6.62 5.1 13v29.75a1.36 1.36 0 0 0 2.72 0v-29.75c0-7.42-2.36-13.03-6.46-15.4z",
    style: {
      fill: "#37474f",
      transformOrigin: "214.613px 119.749px 0"
    },
    id: "eliw4dqcxetck",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dark-bag--inject-4",
    style: {
      transformOrigin: "273px 205.703px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269 110.24c-2.64-1.53-5.9-1.34-9.15.54-7.51 4.33-13.62 16.86-13.62 27.92v26.08a1.19 1.19 0 1 0 2.37 0V138.7c0-10.31 5.58-21.91 12.43-25.87 2.53-1.46 4.88-1.65 6.79-.54 2.83 1.63 4.45 5.78 4.45 11.38v26a1.19 1.19 0 1 0 2.37 0v-26c0-6.47-2.05-11.37-5.64-13.43z",
    style: {
      fill: "#263238",
      transformOrigin: "260.435px 137.648px 0"
    },
    id: "el2jbfpy2165b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "309.735px 191.075px 0"
    },
    id: "elejazdag40qw",
    className: "animable",
    d: "m327.27 259.78-7.3-125.38-20.91-12.03-6.86 117.16 35.07 20.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "309.735px 191.075px 0"
    },
    className: "animable",
    d: "m327.27 259.78-7.3-125.38-20.91-12.03-6.86 117.16 35.07 20.25z",
    id: "el0r220suc420d"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "258.895px 202.155px 0"
    },
    id: "eltd53nvcyzi9",
    className: "animable",
    d: "m225.59 164.78-6.86 117.16 73.47-42.41 6.86-117.16-73.47 42.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "258.895px 202.155px 0"
    },
    className: "animable",
    d: "m225.59 164.78-6.86 117.16 73.47-42.41 6.86-117.16-73.47 42.41z",
    id: "el6i4bengdu9m"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "236.27px 233.485px 0"
    },
    id: "el9yas7m3z3ad",
    className: "animable",
    d: "m225.59 164.78 20.91 12.04 7.31 125.37-35.08-20.25 6.86-117.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "236.27px 233.485px 0"
    },
    className: "animable",
    d: "m225.59 164.78 20.91 12.04 7.31 125.37-35.08-20.25 6.86-117.16z",
    id: "elnxebmn3e5te"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "236.27px 254.66px 0"
    },
    className: "animable",
    d: "m253.81 302.19-15.08-21.16-1.89-73.9-1.88 72.62-16.23 2.19 35.08 20.25z",
    id: "elir8p5b7ahc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 134.4-73.5 42.42 7.3 125.37 73.47-42.41zm-51.6 45.35c-1.44.82-2.62.14-2.62-1.54a5.82 5.82 0 0 1 2.62-4.54c1.45-.84 2.63-.15 2.63 1.54a5.76 5.76 0 0 1-2.66 4.54zm26-15.15c-1.45.83-2.62.14-2.62-1.54a5.8 5.8 0 0 1 2.62-4.54c1.45-.84 2.63-.15 2.63 1.54a5.74 5.74 0 0 1-2.62 4.54z",
    style: {
      fill: "#f04e30",
      transformOrigin: "286.885px 218.295px 0"
    },
    id: "elcmjzbni6q1v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 122.16c-2.65-1.53-5.9-1.34-9.16.54-7.51 4.34-13.61 16.86-13.61 27.93v26.08a1.19 1.19 0 0 0 2.37 0v-26.08c0-10.31 5.57-21.92 12.43-25.87 2.52-1.46 4.87-1.65 6.78-.55 2.83 1.64 4.46 5.78 4.46 11.38v26a1.19 1.19 0 0 0 2.37 0v-26c-.04-6.47-2.1-11.36-5.64-13.43z",
    style: {
      fill: "#37474f",
      transformOrigin: "281.435px 149.464px 0"
    },
    id: "elxzxcucthasn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Label--inject-4",
    style: {
      transformOrigin: "276.643px 68.235px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.18 97.55h-.06a.61.61 0 0 1-.55-.68c.72-7.42 5.87-11.85 8.88-13.83 4.52-3 10-4.33 13.38-3.26a.62.62 0 1 1-.37 1.18c-3-.94-8.16.37-12.33 3.11-2.82 1.86-7.65 6-8.33 12.93a.62.62 0 0 1-.62.55z",
    style: {
      fill: "#263238",
      transformOrigin: "253.937px 88.4819px 0"
    },
    id: "el15yam8mato4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--label--inject-4",
    style: {
      transformOrigin: "285.16px 65.39px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--label--inject-4",
    style: {
      transformOrigin: "285.16px 65.39px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m309.57 38.92-39.82 23-10.15 20.49 10.15 8.78 1.14.66 39.83-23V39.58zm-41.22 39.7a5.39 5.39 0 0 1 2.44-4.22 2.29 2.29 0 0 1 1-.32 2.23 2.23 0 0 1 .24 1.07 5.37 5.37 0 0 1-2.43 4.21 2.3 2.3 0 0 1-1.06.33 2.12 2.12 0 0 1-.19-1.07z",
    style: {
      fill: "#f04e30",
      transformOrigin: "285.16px 65.385px 0"
    },
    id: "el3zfy8isalm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.89 62.57-10.15 20.5 10.15 8.78 39.83-23V39.58zm-.1 17.43c-1.35.78-2.44.15-2.44-1.41a5.39 5.39 0 0 1 2.44-4.22c1.34-.77 2.43-.14 2.43 1.41a5.4 5.4 0 0 1-2.43 4.22z",
    style: {
      fill: "#f04e30",
      transformOrigin: "285.73px 65.715px 0"
    },
    id: "elklz8h7vr3jl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "270.908px 77.1953px 0"
    },
    className: "animable",
    id: "elri843a27qr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.22 75.81a5.4 5.4 0 0 1-2.43 4.19c-1 .56-1.82.39-2.2-.34a2.34 2.34 0 0 0 1.06-.33 5.37 5.37 0 0 0 2.43-4.21 2.19 2.19 0 0 0-.24-1.06 1.21 1.21 0 0 1 .91.34 1.88 1.88 0 0 1 .47 1.41z",
    id: "elq492u6wrz3p",
    style: {
      transformOrigin: "270.908px 77.1953px 0"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "290.235px 50.745px 0"
    },
    className: "animable",
    id: "el7kmgeuiv783"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "290.235px 50.745px 0"
    },
    id: "eloxlrfp772l",
    className: "animable",
    d: "m310.72 39.58-1.15-.66-39.82 22.99 1.14.66 39.83-22.99z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "265.245px 72.49px 0"
    },
    className: "animable",
    id: "el120ef0iao45l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elhrsj4r8xswv",
    style: {
      transformOrigin: "265.245px 72.49px 0"
    },
    className: "animable",
    d: "m270.89 62.57-10.14 20.5-1.15-.66 10.15-20.5 1.14.66z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "265.245px 87.135px 0"
    },
    className: "animable",
    id: "el8cq5vpk3gyv"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellilaz11h6al",
    style: {
      transformOrigin: "265.245px 87.135px 0"
    },
    className: "animable",
    d: "m260.75 83.07 10.14 8.79-1.14-.67-10.15-8.78 1.15.66z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265.36 87.18a7.37 7.37 0 0 1-1.76-.18.62.62 0 0 1-.46-.75.61.61 0 0 1 .75-.46 5.06 5.06 0 0 0 6.07-2.9 3.9 3.9 0 0 0-1.35-5 .63.63 0 0 1-.2-.86.64.64 0 0 1 .87-.2 5.16 5.16 0 0 1 1.83 6.58 6.22 6.22 0 0 1-5.75 3.77z",
    style: {
      fill: "#37474f",
      transformOrigin: "267.376px 81.9591px 0"
    },
    id: "elv7sc3qoxxb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.18 74.7a7.39 7.39 0 0 1-2.05 2.61v2l-1.43.83v-2a5.47 5.47 0 0 1-1.69.51 2.5 2.5 0 0 1-1.33-.17l.78-3.12a2.58 2.58 0 0 0 1.3.17 3.73 3.73 0 0 0 1.45-.49c.9-.53 1.36-1.14 1.36-1.83q0-.56-.39-.6a4.61 4.61 0 0 0-1.24.16 6.67 6.67 0 0 1-1.58.24 1.34 1.34 0 0 1-1.08-.52 2.91 2.91 0 0 1-.45-1.86 7.11 7.11 0 0 1 .74-3.13 7 7 0 0 1 2.13-2.5v-2l1.43-.82v2a4.91 4.91 0 0 1 1.3-.39 2.51 2.51 0 0 1 1.11.07l-.72 3.12a3 3 0 0 0-2.31.34 2.93 2.93 0 0 0-1 .92 1.88 1.88 0 0 0-.32 1c0 .34.13.52.38.55a4.34 4.34 0 0 0 1.23-.18 6.67 6.67 0 0 1 1.58-.24 1.39 1.39 0 0 1 1.08.51 2.79 2.79 0 0 1 .46 1.85 7.15 7.15 0 0 1-.74 2.97z",
    style: {
      fill: "#fafafa",
      transformOrigin: "282.308px 71.16px 0"
    },
    id: "elvae069xsyob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08 69.57a7.19 7.19 0 0 1-2.06 2.6v2l-1.43.82v-2a5.32 5.32 0 0 1-1.69.51 2.48 2.48 0 0 1-1.32-.16l.78-3.13a2.45 2.45 0 0 0 1.29.17 3.56 3.56 0 0 0 1.46-.49 2.2 2.2 0 0 0 1.35-1.83c0-.37-.13-.56-.38-.59a4 4 0 0 0-1.25.16 7.71 7.71 0 0 1-1.57.24 1.37 1.37 0 0 1-1.08-.52 2.89 2.89 0 0 1-.46-1.87 7.25 7.25 0 0 1 .74-3.13 7 7 0 0 1 2.13-2.62v-2L292 57v2a4.68 4.68 0 0 1 1.31-.38 2.38 2.38 0 0 1 1.11.07l-.72 3.11a3 3 0 0 0-2.32.35 2.87 2.87 0 0 0-1 .91 1.94 1.94 0 0 0-.32 1c0 .34.13.52.38.55a4.43 4.43 0 0 0 1.23-.18 6.67 6.67 0 0 1 1.57-.24 1.43 1.43 0 0 1 1.09.51 2.85 2.85 0 0 1 .46 1.85 7.22 7.22 0 0 1-.71 3.02z",
    style: {
      fill: "#fafafa",
      transformOrigin: "291.192px 65.995px 0"
    },
    id: "el315mq6sngy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 64.43a7.42 7.42 0 0 1-2.08 2.57v2l-1.43.83v-2a4.92 4.92 0 0 1-1.69.51 2.39 2.39 0 0 1-1.32-.16l.77-3.12a2.49 2.49 0 0 0 1.3.16 3.52 3.52 0 0 0 1.45-.49 2.2 2.2 0 0 0 1.36-1.73c0-.36-.13-.56-.39-.59a4.27 4.27 0 0 0-1.24.16 7.15 7.15 0 0 1-1.57.24 1.41 1.41 0 0 1-1.09-.52 2.92 2.92 0 0 1-.45-1.87 7.28 7.28 0 0 1 .74-3.13 7 7 0 0 1 2.13-2.61v-2l1.43-.83v2a5 5 0 0 1 1.3-.38 2.56 2.56 0 0 1 1.12.07l-.73 3.11a3 3 0 0 0-2.31.35 2.79 2.79 0 0 0-1 .91 1.87 1.87 0 0 0-.33 1c0 .34.13.53.39.55a3.89 3.89 0 0 0 1.22-.17 7.42 7.42 0 0 1 1.58-.25 1.43 1.43 0 0 1 1.09.51 2.91 2.91 0 0 1 .45 1.86 7.16 7.16 0 0 1-.7 3.02z",
    style: {
      fill: "#fafafa",
      transformOrigin: "300.097px 60.84px 0"
    },
    id: "elpd4nvg31l2",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4",
    style: {
      transformOrigin: "258.942px 326.019px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-4",
    style: {
      transformOrigin: "258.942px 326.019px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Terminal--inject-4",
    style: {
      transformOrigin: "258.942px 326.019px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.83 351.26 241.67 216c-3.72-3.42-7.65-2.82-11.12-.82l-88.72 51.22a8.86 8.86 0 0 0-4.25 5.79l-10.89 43.47a34.64 34.64 0 0 0 40.37 41.48 20.76 20.76 0 0 1 16.94 4.15l104.81 75.83a7.16 7.16 0 0 0 7.47.57l91.72-52.9a8.76 8.76 0 0 0 3.95-6.8v-16.7c.05-5.83.58-6.63-3.12-10.03z",
    style: {
      fill: "#37474f",
      transformOrigin: "258.94px 326.019px 0"
    },
    id: "elpo1xxgdwpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 361.29v16.69a8.75 8.75 0 0 1-3.93 6.8l-91.73 52.9a6.68 6.68 0 0 1-3.83.77V412a7.5 7.5 0 0 0 1.17.08 8.61 8.61 0 0 0 4.23-1.08l89-51.38a5.88 5.88 0 0 0 3.1-4.32 5 5 0 0 0-1.72-4.28l-95.76-88v-.32l96.42 88.64c3.58 3.32 3.05 4.12 3.05 9.95z",
    style: {
      fill: "#263238",
      transformOrigin: "342.269px 350.591px 0"
    },
    id: "elw5b72e0te6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.26 352 240.35 216.92c-2.12-1.95-6.1-2.25-8.84-.66l-86.62 50c-3.72 2.14-4.42 6.07-1.55 8.71l146 134.22c1.86 1.72 5.37 2 7.8.58l89-51.38c2.72-1.57 3.24-4.46 1.12-6.39z",
    style: {
      fill: "#455a64",
      transformOrigin: "265.069px 312.959px 0"
    },
    id: "el44ffj3is6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.62 233.28 127.28 117c2 1.86 1.54 4.61-1.08 6.12l-80.51 46.48c-2.61 1.53-6.39 1.25-8.42-.62l-128.26-117.9a3.41 3.41 0 0 1-.17-5.14c.12-.12.23-.24.36-.35a5.9 5.9 0 0 1 .89-.63l78.77-45.47.47-.28c3.32-1.91 8.11-1.55 10.67.79z",
    id: "eljts8t2bg3z",
    style: {
      transformOrigin: "270.757px 317.565px 0"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 282a6.66 6.66 0 0 0-.89.62c-.13.11-.24.23-.36.35l-.1.12a3.92 3.92 0 0 0 .94 1.25l128.26 118c2 1.87 5.81 2.15 8.42.62l80.51-46.48a5.48 5.48 0 0 0 1.35-1.08 4.1 4.1 0 0 0-.94-1.27L252 237.06c-2.56-2.35-7.35-2.71-10.67-.8l-.47.28z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "270.39px 319.49px 0"
    },
    id: "els4k60vergz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.92 378v-12.5l-99.53 57.45-34.59-31.82-11.8.77-52.34-48.1-.66-12.21-31.69-29.12-19.76 3.92-10.15-9.58-4.73 18.81a34.64 34.64 0 0 0 40.37 41.48 20.76 20.76 0 0 1 16.96 4.19l104.81 75.83a7.16 7.16 0 0 0 7.47.57l91.72-52.9a8.76 8.76 0 0 0 3.92-6.79z",
    style: {
      fill: "#f04e30",
      transformOrigin: "258.888px 367.645px 0"
    },
    id: "elh8b6ixqqxcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246 391.9-52.34-48.1-.66-12.21-31.69-29.12-19.76 3.92-10.15-9.58-4.73 18.81a34.64 34.64 0 0 0 40.37 41.48 20.76 20.76 0 0 1 16.96 4.19l104.81 75.83a6.74 6.74 0 0 0 3.64 1.34v-15.52l-34.65-31.81z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "209.153px 367.635px 0"
    },
    className: "animable",
    id: "el0aewgwjl9tq4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.56 335.91v5.23l48.37 44.48v-5.22z",
    id: "elj055oglywla",
    style: {
      transformOrigin: "221.745px 360.765px 0"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "221.745px 362.385px 0"
    },
    id: "elcn9hdjbipfn",
    className: "animable",
    d: "m197.56 341.14 48.37 44.48v-5.22l-44.85-41.25-3.52 1.99z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.93 350.71zm-18.53-13.55zm59.6 5.93 4.59-2.66-7.14-6.57h-.12l-4.31 2.48c-.22.13-.13.22 0 .34q1.57 1.44 3.14 2.89a.37.37 0 0 0 .52 0c.55-.34 1.12-.64 1.67-1 .25-.15.42-.17.63 0 .41.41.84.81 1.29 1.19.21.18.16.29-.09.43-.58.32-1.14.66-1.71 1-.21.12-.24.21-.07.36.53.47 1 1 1.57 1.44l-2.33 1.34-9-8.24-1.75 1c-.69.4-.52.41-1.05-.08l-1.34-1.22-2.32 1.34-1.8-1.65c-.67.34-1.25.7-1.89 1.07-.46.26-.46.26-.8-.05l-1.08-1c-.37-.34-.37-.34.12-.62l1.82-1.05-1.8-1.65c-.67.39-1.33.76-2 1.16a.39.39 0 0 1-.56-.05c-.38-.37-.79-.73-1.18-1.09s-.37-.34.12-.62l1.84-1.06c-.55-.51-1.08-1-1.58-1.47-.19-.18-.33-.15-.55 0-.56.34-1.15.65-1.71 1a.38.38 0 0 1-.55 0c-.42-.42-.88-.81-1.31-1.22-.18-.18-.32-.18-.55 0q-.84.51-1.71 1c-.26.14-.24.24-.06.4.46.41.89.83 1.35 1.24.14.12.17.22 0 .33l-2.06 1.2-8.46-7.78c-.51-.47-.51-.47-1.18-.08l-1.64.95-1.79-1.65c.68-.4 1.33-.78 2-1.15.25-.14.25-.24.07-.41-1.05-.95-2.08-1.9-3.11-2.86a.41.41 0 0 0-.59-.05c-.51.32-1.06.6-1.56.92-.32.2-.5.22-.78-.05-1-.92-2-1.81-2.94-2.72a.47.47 0 0 0-.7-.07q-3.1 1.82-6.22 3.6c-.31.17-.35.29-.1.51 1 .91 2 1.83 3 2.73.25.23.21.36-.11.52-.55.3-1.08.61-1.6.93-.24.14-.39.13-.56 0-.41-.4-.86-.77-1.26-1.17a.44.44 0 0 0-.65-.06c-.53.33-1.08.64-1.64.95-.26.14-.29.25-.08.42.45.4.89.8 1.31 1.22.07.07.09.26 0 .3-.68.42-1.39.82-2.14 1.25L269 325.9c-.74.43-1.45.83-2.14 1.25-.06 0 0 .22 0 .28.43.42.88.84 1.34 1.24.19.17.17.27-.07.4-.58.32-1.14.66-1.72 1-.24.13-.26.24-.07.4.41.36.8.73 1.19 1.09s.37.34.86.05l3.83-2.2a.79.79 0 0 1 .45-.07c.57.49 1.1 1 1.67 1.52-.68.4-1.32.78-2 1.14-.28.15-.29.26-.07.45.53.47 1 .95 1.55 1.42l2.33-1.33 1.79 1.65-2.32 1.34 1.78 1.64c.67-.38 1.35-.76 2-1.16.25-.14.39-.15.59 0 .49.48 1 .95 1.53 1.43l2.44-1.38a22.71 22.71 0 0 0 1.74 1.65l4.28-2.46a.82.82 0 0 1 .46-.07c.56.49 1.1 1 1.67 1.52l-6.65 3.85c-.13.07-.38.14-.2.31l1.66 1.53c.68-.4 1.34-.76 2-1.15.27-.16.44-.17.66 0 .4.4.85.77 1.25 1.17.21.21.38.2.65 0l3.92-2.27c.26-.16.42-.17.63 0 .4.39.82.78 1.26 1.16.23.19.17.31-.09.45l-1.68 1c-.23.12-.25.22-.07.37.43.38.81.77 1.25 1.14.26.22.27.36-.08.55-.55.28-1 .61-1.58.9-.28.15-.29.26-.08.44 1.12 1 2.26 2 3.33 3.1l-2.33 1.34c.52.48 1 .94 1.55 1.43a.38.38 0 0 0 .55 0l2-1.17c1.2 1 2.22 2 3.37 3 .21.19.19.3-.08.45-.68.38-1.34.77-2 1.16.51.46 1 .94 1.53 1.39.24.21.18.32-.1.47-.53.28-1 .6-1.55.88-.38.19-.35.33-.08.56.5.43.95.88 1.43 1.33.67-.38 1.36-.75 2-1.14a.41.41 0 0 1 .61.05c1 .93 2 1.86 3 2.78.24.22.24.34-.08.52-1.44.82-2.87 1.61-4.26 2.48.52.48 1 .93 1.52 1.4a.41.41 0 0 0 .59.05c.54-.34 1.12-.65 1.66-1 .25-.14.4-.15.59 0 .42.41.85.8 1.3 1.19.2.18.17.29-.08.43q-.87.47-1.71 1c-.09 0-.18.24-.13.29.51.5 1.05 1 1.61 1.5l4.65-2.69c-.51-.47-1-.93-1.5-1.37-.21-.18-.22-.3.06-.46.58-.31 1.15-.64 1.71-1 .24-.15.38-.13.55 0 .43.41.89.81 1.32 1.22a.35.35 0 0 0 .51.05l4.1-2.36c.22-.12.22-.22.06-.36-.45-.4-.87-.81-1.32-1.21-.2-.17-.19-.29.07-.43.57-.32 1.13-.64 1.67-1a.4.4 0 0 1 .59.06c.39.38.83.73 1.2 1.12s.42.24.75.05c2.18-1.29 4.41-2.51 6.57-3.83l-5.06-4.64c-.23-.21-.27-.34.07-.52.55-.28 1-.6 1.59-.89.28-.16.33-.27.09-.48-.46-.39-.88-.8-1.33-1.2-.17-.16-.15-.26.08-.38.59-.33 1.17-.66 1.74-1a.35.35 0 0 1 .52.05l1.37 1.26a.35.35 0 0 0 .49 0l2.05-1.19 3.43 3.15c.15.14.05.22-.1.3-.6.34-1.2.68-1.78 1a.36.36 0 0 1-.52 0c-.43-.41-.89-.81-1.31-1.22a.39.39 0 0 0-.52.33c-.55.34-1.12.67-1.7 1-.28.15-.25.26-.06.43.42.36.83.73 1.21 1.12s.42.26.74.06c.61-.38 1.24-.73 1.91-1.11l1.77 1.62 2.33-1.34c-.45-.42-.89-.81-1.31-1.21s-.55-.36.12-.75c1.24-.72 2.47-1.44 3.73-2.15.31-.17.31-.29.08-.5-2.12-1.8-.88-1.56-3.58-.18a.62.62 0 0 1-.42 0c-.55-.48-1.08-1-1.63-1.49 1.37-.85 2.78-1.61 4.18-2.44.47-.27.47-.27.1-.62s-.98-.88-1.47-1.35zm-60.89-10.57-1.82-1.67c.79-.45 1.5-.9 2.26-1.36-.5-.48-1-1-1.49-1.45-.17-.13-.16-.24.06-.36.6-.33 1.19-.68 1.77-1a.36.36 0 0 1 .5 0l5 4.56c.17.16.15.26-.08.38-.57.32-1.15.65-1.7 1a.39.39 0 0 1-.56 0c-.52-.49-1-.95-1.57-1.42zm9.7 2.46c-.64.36-1.26.73-1.88 1.1a1.35 1.35 0 0 1-.29-.16c-.46-.41-.9-.84-1.37-1.25-.17-.15-.18-.25.06-.38.58-.32 1.16-.65 1.73-1a.4.4 0 0 1 .56 0c.42.4.84.8 1.29 1.19.27.24.2.35-.06.52zm31.31 3.46 2.08-1.18 1.78 1.63-2.17 1.25a.45.45 0 0 1-.31-.07c-.5-.43-1-.88-1.46-1.32-.1-.13-.04-.21.12-.31zm-11.86-3.92 1.81-1a.35.35 0 0 1 .49 0c.45.42.9.84 1.37 1.26.16.14.13.24-.07.36-.59.33-1.17.66-1.74 1a.39.39 0 0 1-.56-.05c-.49-.46-1-.92-1.5-1.37a1.21 1.21 0 0 1 .24-.2zm3.56 3.63c-.17-.15-.13-.25.08-.36l.89-.51.88-.52a.34.34 0 0 1 .47 0c.46.43.92.86 1.4 1.28.16.15.1.24-.08.34l-1.78 1a.34.34 0 0 1-.49 0c-.41-.38-.87-.82-1.33-1.23zm-13.54-9c.16.15.15.24-.06.36-.61.34-1.21.69-1.8 1-.17.1-.29.12-.43 0l-1.6-1.51c.67-.38 1.34-.76 2-1.15a.38.38 0 0 1 .55 0c.47.52.92.93 1.38 1.33zm-4.71 2.68c.19.16.19.27-.06.4q-.87.48-1.71 1a.39.39 0 0 1-.56-.05l-3.1-2.86c-.12-.1-.26-.21 0-.34l4.47-2.58 1.79 1.64c-.65.38-1.29.78-2 1.14-.33.18-.32.31-.08.52.48.39.87.78 1.29 1.16zm-10.84-6.48c-.19-.17-.16-.28.08-.41.5-.27 1-.56 1.47-.84s.59-.27.11-.71-.73-.68-1.11-1c-.2-.18-.18-.3.08-.44.56-.31 1.12-.63 1.67-1a.42.42 0 0 1 .62 0c.5.49 1 .92 1.52 1.41l2.32-1.34c.58.53 1.13 1 1.65 1.53 0 0-.07.23-.17.29-1.43.84-2.88 1.66-4.27 2.54.51.48 1 1 1.5 1.45.19.14.16.25-.07.38-.57.32-1.14.64-1.7 1a.39.39 0 0 1-.56 0c-1-.91-2.04-1.88-3.1-2.83zm18.53 23.95c.72-.41 1.42-.82 2.14-1.22a.46.46 0 0 1 .32.05c.5.44 1 .9 1.47 1.35v.23c-.69.42-1.4.82-2.12 1.24zm18.25 13.33c.18.16.14.27-.08.39-.59.33-1.17.66-1.74 1a.35.35 0 0 1-.49 0c-.22-.22-.46-.42-.69-.63s-.49-.43-.7-.66a.26.26 0 0 1 .06-.3c.59-.36 1.2-.7 1.8-1.05a.36.36 0 0 1 .5.05c.48.41.92.82 1.38 1.23zm-5.41-5c.07.07.09.26 0 .3-.68.41-1.38.8-2.12 1.23l-1.23-1.12c-.56-.52-.57-.52.17-.94l1.68-.95a12.82 12.82 0 0 0 1.54 1.56zm.36-2.55c-.63.33-1.22.71-1.83 1.07a12.78 12.78 0 0 1-1.66-1.42c-.16-.16-.3-.17-.53 0-.57.34-1.15.68-1.74 1a.7.7 0 0 1-.42 0c-.55-.48-1.08-1-1.65-1.51l1.79-1c.58-.34.57-.27.11-.69l-3.18-2.92 1.52-.88c.81-.46.81-.46 1.43.11 2.08 1.91 4.15 3.83 6.25 5.73.29.27.29.43-.05.59zm10.14 2.22c-2.63 1.39-1.49 1.52-3.58-.29a.36.36 0 0 0-.52 0c-2.67 1.46-1.5 1.5-3.58-.24-.22-.19-.18-.3.09-.45l4.32-2.5c1.12 1 2.22 2.05 3.35 3.07.24.23.24.34-.04.49zm-.95-4.87-2.31 1.34-3.34-3.03c-.15-.14-.12-.23.07-.33.61-.34 1.21-.69 1.81-1 .16-.1.29-.13.43 0zm-5.63-5.18c.2.18.2.28-.06.43q-.86.47-1.68 1c-.24.15-.39.16-.58 0-.42-.41-.87-.79-1.29-1.2a.4.4 0 0 0-.58-.05c-.56.34-1.14.66-1.7 1a.41.41 0 0 1-.57 0c-.43-.41-.88-.83-1.34-1.23-.18-.16-.13-.26.09-.38.6-.34 1.18-.69 1.78-1 .18-.11.24-.19.08-.34-.53-.47-1-.95-1.59-1.45-1.48.79-2.88 1.64-4.32 2.47-.28.17-.45.17-.66 0-.41-.41-.84-.8-1.29-1.19-.18-.17-.17-.28.08-.41.56-.32 1.11-.65 1.68-1 .25-.14.29-.24.09-.43-2.35-2.11-4.59-4.29-7-6.37-.66.38-1.31.74-1.93 1.12-.28.17-.44.16-.65-.05-.47-.46-1-.9-1.5-1.39l4.67-2.7-1.45-1.33c-.35-.33-.35-.33.11-.59s1-.59 1.54-.89a.4.4 0 0 1 .58 0c1.11 1 2.21 2 3.33 3.07l2.33-1.34 1.84 1.72a2 2 0 0 0-.26.09c-1.45.86-3 1.66-4.37 2.55l1.77 1.63 1.82-1.05c.48-.28.48-.28.85.06l5 4.63c1.44-.84 2.87-1.65 4.3-2.49.26-.16.41-.17.62 0 .39.39.8.77 1.24 1.13.23.21.23.32-.08.5-1.45.81-2.85 1.64-4.29 2.47 1.21 1.05 2.3 2.07 3.43 3.09zm13.16-1.83c-2.22 1.27-4.41 2.54-6.62 3.82-.28.16-.42.16-.64 0q-2.4-2.23-4.83-4.44c-.24-.22-.19-.33.1-.49 2.08-1.19 4.16-2.39 6.22-3.59.3-.18.45-.17.68.05 1.73 1.61 3.42 3.16 5.13 4.73zm-54.4-11.64zm7.91 27.73a.4.4 0 0 1-.56 0c-1-1-2.08-1.93-3.13-2.88-.18-.17-.17-.28.07-.41l4.06-2.35a.39.39 0 0 1 .55.05c.52.49 1 1 1.58 1.44 1.43-.82 2.85-1.65 4.28-2.46.27-.16.34-.27.1-.47-.52-.45-1-.92-1.52-1.38-1.64.81-3.09 1.8-4.7 2.64l-1.55-1.43a.36.36 0 0 0-.52 0c-.57.33-1.15.65-1.71 1a.41.41 0 0 1-.59-.05c-1.1-1-2.2-2-3.32-3.06-1.44.83-2.87 1.64-4.29 2.48a.48.48 0 0 1-.69-.05 16.74 16.74 0 0 0-1.24-1.14c-.23-.2-.2-.31.08-.47 2.21-1.29 4.46-2.53 6.63-3.85l-3.4-3.13a.32.32 0 0 0-.43 0l-1.82 1c-.19.11-.2.2-.05.33l1.6 1.47-1.55.89c-.8.47-.8.47-1.43-.11l-1.14-1.04c-.68.4-1.3.77-1.94 1.11-.33.18-.32.31-.08.53 1.09 1 2.22 2 3.26 3l-4.59 2.66c.45.52 1 .95 1.53 1.46.2.19.35.18.59 0 .56-.34 1.14-.66 1.71-1a.35.35 0 0 1 .49 0c.44.41.89.83 1.35 1.23.2.18.13.28-.09.41-.56.31-1.09.64-1.65.94-.29.16-.3.27-.08.47 1.13 1 2.17 2 3.34 3 .69-.4 1.32-.78 2-1.16a.61.61 0 0 1 .39 0c.57.49 1.11 1 1.69 1.54l-2.28 1.32 1.8 1.65c.68-.4 1.34-.77 2-1.15a.38.38 0 0 1 .56 0c.43.42.89.82 1.34 1.24a.35.35 0 0 0 .49 0l1.78-1c.22-.12.21-.22.05-.36-.52-.48-1.07-.95-1.54-1.45l2.28-1.32c.55.46 1 .93 1.55 1.41a.39.39 0 0 0 .56.05c.57-.34 1.15-.68 1.74-1 .25-.13.26-.23.07-.4-.53-.47-1-.95-1.55-1.42-.68.52-1.37.9-2.04 1.3zm-2.65 1.52c-.74.43-1.44.84-2.15 1.23a.44.44 0 0 1-.32 0L275 362.8l2.11-1.21a.47.47 0 0 1 .35 0c.54.5 1.04 1 1.62 1.52zm-3.35-6.03c-.48.26-.94.53-1.4.8-.68.4-.67.3-.15.78l1.1 1c.18.15.17.26-.06.39-.59.32-1.17.66-1.74 1a.39.39 0 0 1-.53 0c-.51-.49-1.05-1-1.57-1.46s-1-.92-1.51-1.38c-.2-.17-.22-.29.06-.45q2-1.14 4-2.3c.23-.14.38-.15.56 0 .43.41.86.81 1.32 1.21.23.16.16.27-.08.41zm24.94-30.55 15.86-9.16-12.21-11.23c-.37-.34-.37-.34-.85-.06l-15.38 8.88c-.45.26-.45.26-.1.57l11.89 10.94c.35.3.35.31.79.05zm-8.51-11.24q5.43-3.12 10.83-6.25c.36-.21.53-.17.78.07l4.16 3.83c1.39 1.28 2.77 2.56 4.17 3.83.26.23.22.36-.1.54q-5.43 3.12-10.84 6.26c-.3.17-.46.18-.71-.05q-4.17-3.85-8.39-7.71c-.24-.23-.21-.35.1-.53zm-33.46 35.48 15.44-8.93c.45-.25.45-.25.1-.57l-11.89-10.93c-.34-.32-.35-.32-.79-.06-5.27 3.06-10.59 6.07-15.83 9.16 4 3.78 8.17 7.51 12.23 11.28.25.22.41.23.74.04zm-8.6-10.77c-.22-.2-.19-.31.09-.47q5.47-3.15 10.93-6.32a.46.46 0 0 1 .65.07c1.41 1.31 2.83 2.6 4.24 3.9s2.77 2.56 4.17 3.83c.24.21.21.32-.09.5q-5.46 3.13-10.9 6.29a.46.46 0 0 1-.66 0q-4.2-3.93-8.43-7.81zm43.85 20L278 369.09c4 3.79 8.18 7.51 12.24 11.29.25.23.41.24.74.05q7.94-4.6 15.89-9.18-6.14-5.64-12.26-11.28c-.21-.23-.37-.24-.7-.05zm8.49 11.25c-3.62 2.09-7.25 4.18-10.86 6.28a.5.5 0 0 1-.72-.06q-4.17-3.86-8.36-7.68c-.25-.23-.25-.36.09-.55 1.83-1 3.65-2.1 5.47-3.15s3.61-2.07 5.4-3.12a.47.47 0 0 1 .68.05q4.18 3.87 8.41 7.73c.24.23.18.33-.11.5zm17.65-50.58-2.3 1.33-1.56-1.44a.36.36 0 0 0-.52 0c-.58.34-1.16.68-1.75 1-.23.13-.22.24-.05.39.45.41.9.82 1.34 1.24.17.16.3.16.52 0 .56-.34 1.15-.65 1.7-1a.4.4 0 0 1 .59.05c.42.4.84.8 1.29 1.19.21.18.16.28-.09.42-1.46.83-2.86 1.65-4.31 2.49.58.53 1.12 1 1.69 1.54a.61.61 0 0 0 .39 0c.55-.3 1.08-.61 1.61-.92s.44-.25.8.07c1 .91 2 1.82 3 2.74a.41.41 0 0 0 .59.05c.54-.33 1.1-.63 1.64-1a.44.44 0 0 1 .63 0c.38.38.76.74 1.18 1.09s.28.37-.08.57c-1.44.79-2.79 1.64-4.25 2.42-1.1-1-2.2-2-3.28-3a.45.45 0 0 0-.66-.05c-.53.33-1.08.65-1.64 1-.26.15-.3.25-.08.45 1.14 1 2.18 2.05 3.36 3 .76-.46 1.52-.87 2.32-1.28.63.53 1.22 1 1.81 1.6.68-.39 1.31-.73 1.9-1.1.35-.23.53-.18.77.07.39.39.83.76 1.23 1.14a.36.36 0 0 0 .5 0c.58-.34 1.17-.69 1.77-1 .22-.12.23-.22.07-.36l-1.24-1.14c-.34-.31-.34-.31.1-.57l1.84-1.06c-1.62-1.65-3.46-3.19-5.16-4.81-.16-.15-.3-.13-.49 0-.57.34-1.15.66-1.71 1a.4.4 0 0 1-.59-.05c-.42-.4-.85-.8-1.29-1.18-.19-.17-.17-.28.07-.41.55-.3 1.06-.63 1.61-.92.31-.17.37-.29.11-.52-1.17-1.01-2.21-2.05-3.38-3.04zM291.8 350.4l-1.3-1.2c-.51-.47-.51-.47.16-.86l1.64-.94-3.58-3.29-2.23 1.29s-.05.07-.07.11a.59.59 0 0 1 .14.06l3.24 3c.16.14.1.23-.07.33l-1.78 1a.38.38 0 0 1-.53-.05c-.42-.41-.88-.8-1.31-1.21a.37.37 0 0 0-.55 0l-4 2.32c-.23.14-.28.24-.08.41.45.39.89.8 1.32 1.21a.38.38 0 0 0 .55 0c.56-.33 1.14-.65 1.7-1a.39.39 0 0 1 .56.05c.52.49 1.05 1 1.58 1.44 1.48-.91 3.05-1.78 4.61-2.67zm-5.38-4.89zm.74 7.57zm56.14-8.21c.57-.31 1.11-.65 1.68-1 .23-.13.24-.23.07-.39-.47-.41-.93-.83-1.37-1.25a.33.33 0 0 0-.46 0l-1.81 1c-.23.12-.19.22 0 .36.45.4.87.81 1.33 1.2.2.18.17.29-.09.43-.56.31-1.11.65-1.68 1-.23.13-.27.23-.08.41 1 .94 2.08 1.9 3.11 2.86.2.19.35.17.59 0 .65-.39 1.31-.77 2-1.15l2.06-1.18c.19-.11.25-.2.08-.36-.47-.41-.93-.83-1.37-1.26a.39.39 0 0 0-.53 0c-.56.34-1.14.66-1.7 1a.4.4 0 0 1-.57 0c-.41-.39-.82-.78-1.26-1.16-.3-.23-.3-.38 0-.51zm-48.45 11.82zM283 342.29c-.06-.05-.15-.09-.24-.15l-2.06 1.19c-.23.12-.12.22 0 .34 1.05 1 2.1 1.91 3.13 2.88.21.19.36.17.6 0a13.15 13.15 0 0 1 2-1.07 1.2 1.2 0 0 0-.17-.21q-1.63-1.48-3.26-2.98zm3.43 3.22zm14.87 10.15zm-2.07-1.49-4.35 2.52c.51.48 1 .94 1.53 1.43.2.19.34.18.59 0l4.3-2.49-1.55-1.46a.37.37 0 0 0-.53 0zm-19.53-7.59c-.6.36-1.22.72-1.84 1.07-.17.09-.2.18-.06.31.48.44 1 .88 1.44 1.33a.34.34 0 0 0 .47 0l.91-.53c.3-.17.61-.33.88-.52.08-.05.12-.23.06-.29-.46-.46-.95-.89-1.43-1.34a.32.32 0 0 0-.44-.03zm-17.56 4.79c-.63.34-1.25.69-1.85 1.06-.08.05-.13.22-.08.27.52.5 1.06 1 1.63 1.51.75-.43 1.44-.82 2.12-1.23a.19.19 0 0 0 0-.25c-.46-.46-.94-.9-1.44-1.33a.53.53 0 0 0-.39-.03zm29.69-1zm-10.3-12.93zm-.75 2.78a.35.35 0 0 0 .49.05c.6-.35 1.2-.7 1.81-1 .18-.11.21-.2.06-.33l-1.61-1.46-2.32 1.33c.52.49 1.05.96 1.56 1.45zm-4.69 3c-.6.35-1.2.7-1.81 1-.19.11-.2.2 0 .33l1.42 1.31c.13.13.25.12.42 0l1.84-1.06c.18-.1.2-.19.06-.31s-.48-.43-.71-.65l-.71-.65a.33.33 0 0 0-.52.11zm10 15.77zm-2.32 1.34zm.53-3zm-2.3 1.43 1.79 1.65 2.32-1.34-1.79-1.64zm-6.38-23.24zm-3.86-.46c-.2.11-.2.2-.06.33.47.41.93.83 1.37 1.26.19.18.33.15.55 0 .66-.39 1.33-.77 2-1.15l-1.78-1.65zm7.45 3.75zm-3.8-.49c-.24.14-.27.24-.08.41.45.39.9.8 1.32 1.21a.39.39 0 0 0 .56 0c.66-.4 1.33-.78 2-1.17l-1.79-1.64c-.69.43-1.35.87-2.03 1.19zm33.31-13.86-1.8 1c-.19.11-.22.2-.07.34.48.43.94.87 1.43 1.3a.52.52 0 0 0 .34.06c.71-.39 1.41-.8 2.16-1.23-.58-.53-1.11-1-1.63-1.5-.15-.09-.29-.06-.45.03zm-6.16 35.84zm-2.13 1.5c.5.45 1 .9 1.49 1.35a.47.47 0 0 0 .31 0c.72-.4 1.42-.81 2.13-1.22l-1.8-1.66-2 1.17c-.17.12-.32.2-.15.36zm21.67-18.12c-.33.16-.63.34-.93.52l-.93.53c-.16.09-.23.18-.08.31.49.44 1 .89 1.46 1.33a.5.5 0 0 0 .38 0c.64-.35 1.26-.71 1.88-1.08a.23.23 0 0 0 0-.28c-.46-.45-.95-.89-1.45-1.33a.52.52 0 0 0-.35 0zM295 353.91c.28-.16.34-.27.1-.47-.53-.45-1-.92-1.52-1.39l2.3-1.34-1.78-1.64-2.31 1.34 1.77 1.64c-.67.39-1.33.78-2 1.15-.26.15-.26.25-.06.43.52.46 1 .94 1.54 1.41l-7 4c.52.48 1 1 1.56 1.45.17.17.31.16.52 0l6.67-3.86-1.71-1.63c.65-.34 1.29-.73 1.92-1.09zm6.62-33.43c2.19-1.28 4.38-2.53 6.58-3.8-1.64-1.6-3.39-3.12-5.06-4.7-.25-.23-.42-.24-.74-.05-2.18 1.3-4.42 2.51-6.56 3.83 1.69 1.56 3.39 3.1 5.07 4.67.28.23.43.23.74.05zM259 344.68a.43.43 0 0 0 .62.05c1-.62 2.11-1.23 3.17-1.84l3.11-1.79c.28-.15.34-.26.11-.47-1.64-1.48-3.27-3-4.88-4.48a.41.41 0 0 0-.59 0q-3.17 1.84-6.36 3.67c-.26.15-.25.26-.06.43q2.48 2.19 4.88 4.43zm33.84 21.21c-2.19 1.28-4.38 2.54-6.58 3.81 1.63 1.6 3.39 3.11 5 4.69.25.23.41.25.74.06 2.18-1.29 4.42-2.51 6.57-3.83-1.7-1.56-3.39-3.1-5.07-4.67-.16-.22-.31-.24-.63-.06z",
    style: {
      fill: "#263238",
      transformOrigin: "297.26px 343.18px 0"
    },
    id: "el0s627e44cgtm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.13 299.22 52.56 48.32-68.43 39.51-52.56-48.32 68.43-39.51m.23-2.05-71.45 41.25L289 389.09l71.45-41.25-55.12-50.67z",
    style: {
      fill: "#f04e30",
      transformOrigin: "297.18px 343.13px 0"
    },
    id: "el6to759izjfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 285.43-2.51-3.53a.27.27 0 0 1-.05-.28.47.47 0 0 1 .18-.19l1.68-1a.38.38 0 0 1 .26-.06.43.43 0 0 1 .23.09l.07.08 4.57 6.67a.35.35 0 0 1 .06.35.68.68 0 0 1-.32.36l-1.06.61a.86.86 0 0 1-.53.13 1.31 1.31 0 0 1-.48-.1l-3.18-1.49 1.27 2.59a.75.75 0 0 1 0 .37.58.58 0 0 1-.3.35l-1.06.61a1.15 1.15 0 0 1-.55.14.76.76 0 0 1-.46-.12l-7.87-4.77-.09-.06a.21.21 0 0 1-.07-.19.26.26 0 0 1 .14-.17l1.67-1a.56.56 0 0 1 .3-.08.57.57 0 0 1 .36.1l4.14 2.58-1-2.07a.58.58 0 0 1-.06-.23c0-.1.06-.19.21-.28l1.2-.69a.59.59 0 0 1 .43-.09 1.34 1.34 0 0 1 .29.1z",
    style: {
      fill: "#455a64",
      transformOrigin: "193.15px 285.749px 0"
    },
    id: "elngctvttc3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.48 280.78a.56.56 0 0 1 .61 0l1 1a.24.24 0 0 1 .08.23.31.31 0 0 1-.16.21l-6.05 3.5a.56.56 0 0 1-.32.06.4.4 0 0 1-.29-.11l-6.35-5.84a.25.25 0 0 1-.08-.24.32.32 0 0 1 .16-.21l5.95-3.43a.56.56 0 0 1 .32-.07.48.48 0 0 1 .29.12l1 1a.23.23 0 0 1 .08.23.32.32 0 0 1-.16.21l-3.93 2.27 1.06 1 3.65-2.1a.56.56 0 0 1 .61 0l1.05 1a.24.24 0 0 1 .08.23.31.31 0 0 1-.16.21l-3.65 2.11 1.1 1z",
    style: {
      fill: "#455a64",
      transformOrigin: "203.545px 280.831px 0"
    },
    id: "el888vqbwszvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.54 276.12a.68.68 0 0 1 .32-.07.43.43 0 0 1 .29.12l1 1a.23.23 0 0 1 .08.23.28.28 0 0 1-.16.21l-5.86 3.39a.56.56 0 0 1-.32.07.45.45 0 0 1-.29-.12l-6.36-5.84a.23.23 0 0 1-.08-.23.31.31 0 0 1 .16-.21l1.67-1a.7.7 0 0 1 .33-.07.43.43 0 0 1 .28.12l5.05 4.64z",
    style: {
      fill: "#455a64",
      transformOrigin: "211.695px 277.336px 0"
    },
    id: "elg3v2slz7oeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.22 271.7.33.34.46.43.48.43c.16.14.28.25.38.32a2.77 2.77 0 0 0 .55.33 1.89 1.89 0 0 0 .64.17 2.1 2.1 0 0 0 .74-.05 2.61 2.61 0 0 0 .82-.33 2.55 2.55 0 0 0 .63-.48 1.22 1.22 0 0 0 .27-.45.74.74 0 0 0 0-.39 1 1 0 0 0-.11-.31.57.57 0 0 1-.08-.29c0-.07.09-.14.23-.23l1.67-1a.49.49 0 0 1 .27-.06.43.43 0 0 1 .23.09 2 2 0 0 1 .55 2.25 3.56 3.56 0 0 1-.74 1.2 5.5 5.5 0 0 1-1.37 1.08 7.06 7.06 0 0 1-1.85.75 6.29 6.29 0 0 1-1.81.18 5.14 5.14 0 0 1-1.63-.33 4.72 4.72 0 0 1-1.34-.76c-.29-.24-.59-.5-.89-.79s-.6-.55-.86-.82a2.85 2.85 0 0 1-.73-1.13 2.23 2.23 0 0 1-.06-1.23 2.92 2.92 0 0 1 .65-1.24 5.46 5.46 0 0 1 1.44-1.15 7.18 7.18 0 0 1 1.75-.72 7 7 0 0 1 1.77-.25 4.94 4.94 0 0 1 1.61.22 3.44 3.44 0 0 1 1.27.68.21.21 0 0 1 .07.19.26.26 0 0 1-.14.17l-1.67 1a.64.64 0 0 1-.36.11 1.24 1.24 0 0 1-.36-.12 2.21 2.21 0 0 0-.4-.16 2.13 2.13 0 0 0-.53-.07 2.73 2.73 0 0 0-.65.09 3 3 0 0 0-.79.34 2.17 2.17 0 0 0-.63.51 1.08 1.08 0 0 0-.24.51.84.84 0 0 0 .09.49 1.78 1.78 0 0 0 .34.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.681px 271.472px 0"
    },
    id: "elqda77x3gu3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.77 267.84a3 3 0 0 1-.72-1.14 2.12 2.12 0 0 1-.07-1.22 3 3 0 0 1 .65-1.24 5.46 5.46 0 0 1 1.46-1.15 6.88 6.88 0 0 1 1.87-.76 6.28 6.28 0 0 1 1.8-.19 5.37 5.37 0 0 1 1.62.33 4.7 4.7 0 0 1 1.35.77c.3.25.61.52.92.8l.84.81a3.13 3.13 0 0 1 .72 1.14 2.15 2.15 0 0 1 .07 1.23 2.84 2.84 0 0 1-.66 1.24 5.35 5.35 0 0 1-1.45 1.14 6.86 6.86 0 0 1-1.87.77 5.88 5.88 0 0 1-1.79.19 5.09 5.09 0 0 1-1.63-.34 4.7 4.7 0 0 1-1.35-.77q-.43-.36-.9-.78zm7.31-1.67-.37-.38-.43-.41-.45-.4-.41-.33a2.59 2.59 0 0 0-.58-.34 2.51 2.51 0 0 0-.67-.15 2.3 2.3 0 0 0-.73.06 2.68 2.68 0 0 0-.78.32 2.18 2.18 0 0 0-.6.48 1.12 1.12 0 0 0-.25.5 1 1 0 0 0 .05.51 1.79 1.79 0 0 0 .32.49c.1.11.21.24.35.37l.43.4.45.41c.15.13.29.24.43.34a2.42 2.42 0 0 0 1.25.5 2.52 2.52 0 0 0 1.51-.38c.52-.31.81-.63.85-1a1.31 1.31 0 0 0-.37-.99z",
    style: {
      fill: "#455a64",
      transformOrigin: "228.63px 266.351px 0"
    },
    id: "elbv617flzevk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54 262.6a1.44 1.44 0 0 1-.33-.05l-2.83-.8 3.26 3a.25.25 0 0 1 .09.23.31.31 0 0 1-.17.21l-1.67 1a.49.49 0 0 1-.32.07.45.45 0 0 1-.29-.11l-6.36-5.85a.23.23 0 0 1-.08-.23.35.35 0 0 1 .16-.21l1.48-.85a.78.78 0 0 1 .49-.12h.33l4.79 1.32-.66-3.7a.68.68 0 0 1 0-.24c0-.12.1-.22.27-.32l1.48-.86a.68.68 0 0 1 .32-.07.45.45 0 0 1 .29.12l6.36 5.84a.24.24 0 0 1 .08.23.31.31 0 0 1-.16.22l-1.67 1a.56.56 0 0 1-.32.07.45.45 0 0 1-.29-.12l-3.26-3 .43 2.19a1 1 0 0 1 0 .24.38.38 0 0 1-.22.25l-.82.48a.65.65 0 0 1-.38.06z",
    style: {
      fill: "#455a64",
      transformOrigin: "238.534px 260.642px 0"
    },
    id: "elqccs3n326b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 255.06a.49.49 0 0 1 .32-.07.51.51 0 0 1 .29.11l1 1a.27.27 0 0 1 .09.23.33.33 0 0 1-.17.22l-6 3.49a.58.58 0 0 1-.32.06.38.38 0 0 1-.21-.1l-6.36-5.84a.27.27 0 0 1-.09-.23.33.33 0 0 1 .17-.22l5.94-3.43a.68.68 0 0 1 .32-.07.45.45 0 0 1 .29.12l1.05 1a.23.23 0 0 1 .08.23.33.33 0 0 1-.16.21l-3.98 2.23 1.06 1 3.65-2.11a.49.49 0 0 1 .32-.07.51.51 0 0 1 .29.11l1 1a.27.27 0 0 1 .09.23.33.33 0 0 1-.17.22l-3.64 2.1 1.1 1z",
    style: {
      fill: "#455a64",
      transformOrigin: "248.125px 255.156px 0"
    },
    id: "elcy9k2t6jple",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.1 296.71a7 7 0 0 1 1.68-.71 6.23 6.23 0 0 1 1.53-.21 4 4 0 0 1 1.24.15 2.55 2.55 0 0 1 .86.42.22.22 0 0 1 .09.23.32.32 0 0 1-.17.21l-.9.52a1 1 0 0 1-.38.13 1.81 1.81 0 0 1-.38-.05 2.69 2.69 0 0 0-1-.06 3.6 3.6 0 0 0-1.34.5 3.76 3.76 0 0 0-.58.42 1.59 1.59 0 0 0-.36.44.73.73 0 0 0-.1.44.59.59 0 0 0 .2.38 1.12 1.12 0 0 0 .5.27 1.79 1.79 0 0 0 .65 0 6.88 6.88 0 0 0 1-.27L215 299a13.49 13.49 0 0 1 1.62-.49 5.4 5.4 0 0 1 1.32-.14 3.14 3.14 0 0 1 1.08.21 2.72 2.72 0 0 1 .89.56 1.92 1.92 0 0 1 .57.9 1.72 1.72 0 0 1-.08 1 3.31 3.31 0 0 1-.73 1.06 6.7 6.7 0 0 1-1.39 1 8.34 8.34 0 0 1-1.5.66 6.61 6.61 0 0 1-1.54.32 4.66 4.66 0 0 1-1.41-.09 2.75 2.75 0 0 1-1.13-.53.21.21 0 0 1-.1-.23.37.37 0 0 1 .17-.21l.9-.52a.94.94 0 0 1 .39-.13 1 1 0 0 1 .37.05l.47.11a2.14 2.14 0 0 0 .57 0 3.71 3.71 0 0 0 .71-.16 6 6 0 0 0 .87-.41 7.75 7.75 0 0 0 .7-.47 2.17 2.17 0 0 0 .47-.5 1 1 0 0 0 .18-.48.56.56 0 0 0-.21-.45.91.91 0 0 0-.54-.22 2.29 2.29 0 0 0-.77.1c-.31.08-.67.19-1.09.34s-.91.32-1.46.51a12.64 12.64 0 0 1-1.4.39 5 5 0 0 1-1.19.09 3.06 3.06 0 0 1-1-.25 3.2 3.2 0 0 1-.92-.61 1.82 1.82 0 0 1-.56-.9 1.69 1.69 0 0 1 .06-1 3 3 0 0 1 .65-1 5.17 5.17 0 0 1 1.13-.8z",
    style: {
      fill: "#f04e30",
      transformOrigin: "214.866px 299.943px 0"
    },
    id: "el2gtuoihdfie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.59 295a.27.27 0 0 1-.06-.25.37.37 0 0 1 .18-.19l1-.6a.57.57 0 0 1 .32-.08.45.45 0 0 1 .29.12 2.7 2.7 0 0 1 .55.9 1.81 1.81 0 0 1 0 1.06 2.91 2.91 0 0 1-.63 1.16 5.29 5.29 0 0 1-1.49 1.17 6.38 6.38 0 0 1-1.76.71 5.53 5.53 0 0 1-1.7.15 5.11 5.11 0 0 1-1.6-.37 5.59 5.59 0 0 1-1.4-.82c-.27-.22-.56-.47-.86-.75s-.57-.53-.8-.77a3.7 3.7 0 0 1-.78-1.19 2.21 2.21 0 0 1-.13-1.21 2.74 2.74 0 0 1 .59-1.18 4.88 4.88 0 0 1 1.36-1.09 7 7 0 0 1 1.9-.78 6 6 0 0 1 1.69-.19 4.48 4.48 0 0 1 1.42.28 4.25 4.25 0 0 1 1.06.59.21.21 0 0 1 .1.23.34.34 0 0 1-.18.21l-1 .6a.62.62 0 0 1-.31.08.5.5 0 0 1-.33-.1 2.42 2.42 0 0 0-.56-.25 3.24 3.24 0 0 0-.72-.08 3.45 3.45 0 0 0-.85.13 4 4 0 0 0-1 .42 2.28 2.28 0 0 0-.75.61 1.41 1.41 0 0 0-.31.64 1.27 1.27 0 0 0 .09.66 2.27 2.27 0 0 0 .42.62c.24.24.5.5.8.78s.59.52.86.74a2.87 2.87 0 0 0 1.59.66 3.4 3.4 0 0 0 .94-.07 3.79 3.79 0 0 0 1.76-1 1.65 1.65 0 0 0 .37-.58 1 1 0 0 0 .06-.53 1 1 0 0 0-.13-.44z",
    style: {
      fill: "#f04e30",
      transformOrigin: "223.318px 294.98px 0"
    },
    id: "el2uyclmvf4zl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.24 286.39a.64.64 0 0 1 .39-.1 1.49 1.49 0 0 1 .43.12l9.34 3.92.08.05a.26.26 0 0 1 .09.24.34.34 0 0 1-.17.21l-.91.53a.77.77 0 0 1-.44.13 1.61 1.61 0 0 1-.31-.07l-1.64-.69-4 2.33.54 1.32a.42.42 0 0 1 0 .23c0 .09-.11.19-.28.28l-.92.53a.49.49 0 0 1-.32.07.54.54 0 0 1-.29-.11l-.05-.07-3.1-7.53a.63.63 0 0 1-.07-.33.37.37 0 0 1 .22-.25zm5 3.56-4.21-1.77 1.4 3.39z",
    style: {
      fill: "#f04e30",
      transformOrigin: "233.591px 290.891px 0"
    },
    id: "elxyuzwfyo71l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7 286.61a.67.67 0 0 1-.42.11h-.3l-7.67-1.7 4.06 3.73a.23.23 0 0 1 .08.23.28.28 0 0 1-.16.21l-1 .6a.56.56 0 0 1-.32.07.48.48 0 0 1-.29-.12l-6.35-5.84a.24.24 0 0 1-.09-.23.31.31 0 0 1 .16-.21l.9-.52a.74.74 0 0 1 .42-.11h.3l7.67 1.7-4.06-3.72a.25.25 0 0 1-.08-.24.32.32 0 0 1 .16-.21l1-.6a.58.58 0 0 1 .32-.06.47.47 0 0 1 .3.11l6.35 5.85a.25.25 0 0 1 .09.23.31.31 0 0 1-.17.21z",
    style: {
      fill: "#f04e30",
      transformOrigin: "241.005px 284.779px 0"
    },
    id: "elhex11a699zb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.57 273.49a.58.58 0 0 1 .32-.07.43.43 0 0 1 .29.12l.7.64a.25.25 0 0 1 .09.23.29.29 0 0 1-.17.21l-2.29 1.38 5.39 5a.25.25 0 0 1 .09.23.34.34 0 0 1-.17.21l-1 .59a.51.51 0 0 1-.32.07.45.45 0 0 1-.29-.11l-5.4-5-2.29 1.33a.66.66 0 0 1-.32.07.45.45 0 0 1-.29-.12l-.7-.64a.26.26 0 0 1-.09-.23.29.29 0 0 1 .17-.21z",
    style: {
      fill: "#f04e30",
      transformOrigin: "250.555px 277.761px 0"
    },
    id: "ell5postjndk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28 275.2a3.94 3.94 0 0 1-.77-1.12 2.19 2.19 0 0 1-.15-1.18 2.6 2.6 0 0 1 .58-1.18 4.91 4.91 0 0 1 1.42-1.14 6.68 6.68 0 0 1 1.83-.75 5.65 5.65 0 0 1 1.72-.13 5 5 0 0 1 1.54.37 5.12 5.12 0 0 1 1.33.8l.43.36.47.43.47.43.39.39a3.71 3.71 0 0 1 .76 1.12 2.1 2.1 0 0 1 .16 1.18 2.58 2.58 0 0 1-.59 1.18 5 5 0 0 1-1.42 1.13 6.72 6.72 0 0 1-1.84.76 5.69 5.69 0 0 1-1.72.14 4.71 4.71 0 0 1-1.54-.38 5.57 5.57 0 0 1-1.31-.79l-.43-.37-.48-.43-.46-.43q-.22-.21-.39-.39zm5.83-3.29a2.81 2.81 0 0 0-1.7-.67 3.31 3.31 0 0 0-1.82.47 2 2 0 0 0-1 1.19 1.47 1.47 0 0 0 .51 1.35c.23.24.5.5.8.78l.86.75a2.86 2.86 0 0 0 1.69.66 3.24 3.24 0 0 0 1.82-.48 2 2 0 0 0 1-1.18 1.46 1.46 0 0 0-.5-1.35c-.23-.23-.5-.49-.81-.77s-.59-.54-.85-.75z",
    style: {
      fill: "#f04e30",
      transformOrigin: "259.91px 273.844px 0"
    },
    id: "elv07zp31x8zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 303.5a18.45 18.45 0 0 1 3.71-1.65 12.2 12.2 0 0 1 3.55-.56 9.55 9.55 0 0 1 3.3.59 8.74 8.74 0 0 1 2.89 1.8 6.11 6.11 0 0 1 1.76 2.48 3.84 3.84 0 0 1 0 2.46 6.3 6.3 0 0 1-1.51 2.38 14.57 14.57 0 0 1-3 2.27l-3.77 2.17 4.63 4.25a.56.56 0 0 1 .2.53.71.71 0 0 1-.38.49l-3.89 2.29a1.3 1.3 0 0 1-.74.15 1.1 1.1 0 0 1-.67-.26l-14.64-13.46a.56.56 0 0 1-.2-.54.7.7 0 0 1 .38-.49zm3.34 8.7 3.61-2.09a3.79 3.79 0 0 0 1.63-1.56 1.46 1.46 0 0 0-.57-1.73 2.82 2.82 0 0 0-2.18-.8 5.65 5.65 0 0 0-2.46.8l-3.62 2.08z",
    style: {
      fill: "#f04e30",
      transformOrigin: "229.321px 312.223px 0"
    },
    id: "elozlwyhiv1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.42 291.72a1.91 1.91 0 0 1 1.15-.28 2.84 2.84 0 0 1 .92.21l20.69 9.43a1.75 1.75 0 0 1 .46.25.44.44 0 0 1 .16.43.56.56 0 0 1-.31.4l-3.7 2.14a1.83 1.83 0 0 1-1 .3 1.62 1.62 0 0 1-.68-.16l-2.71-1.26-7.82 4.52 1.06 2.2a.74.74 0 0 1 .07.52c0 .22-.26.44-.65.67l-3.7 2.13a1 1 0 0 1-.6.13.94.94 0 0 1-.55-.21 1.15 1.15 0 0 1-.22-.38l-7.88-16.83a1.27 1.27 0 0 1-.07-.71 1.16 1.16 0 0 1 .65-.75zm5.15 11.86 4.76-2.75-7.82-3.62z",
    style: {
      fill: "#f04e30",
      transformOrigin: "255.413px 302.395px 0"
    },
    id: "elycgih77n0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.46 294.91a.56.56 0 0 1 .2.53.73.73 0 0 1-.38.49l-3.85 2.22a1.23 1.23 0 0 1-.74.16 1.1 1.1 0 0 1-.67-.26l-4.83-4.44-16.42-4.94a1 1 0 0 1-.42-.2.48.48 0 0 1-.16-.44.59.59 0 0 1 .31-.39l4-2.33a1.87 1.87 0 0 1 1.11-.3 2.85 2.85 0 0 1 .69.11l9.28 3-1.84-7.28a1 1 0 0 1 0-.52c0-.25.26-.49.65-.72l4-2.32a1 1 0 0 1 .6-.13.88.88 0 0 1 .54.21.54.54 0 0 1 .18.34l2.85 12.78z",
    style: {
      fill: "#f04e30",
      transformOrigin: "266.926px 287.731px 0"
    },
    id: "eldoljy4qfj2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "270.945px 317.59px 0"
    },
    className: "animable",
    id: "elupjugzqtaeo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "272.31px 318.77px 0"
    },
    id: "elzju9o9wxo5",
    className: "animable",
    d: "m299.1 276.04-17.52-16.11-36.06 101.57 17.52 16.11 36.06-101.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.73 328.82 322 301.52l-34.89 98.27 2.74 2.52c2 1.87 5.81 2.15 8.42.62l34.1-19.68z",
    style: {
      fill: "#fff",
      transformOrigin: "319.42px 352.719px 0"
    },
    id: "eluus2wcv2gxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.57 346.85 36.07-101.57-13-12c-2.56-2.34-7.35-2.7-10.67-.79l-.47.28-13.34 7.7-38 70.1z",
    style: {
      fill: "#fff",
      transformOrigin: "227.9px 289.056px 0"
    },
    id: "elbxg8lrr0huo",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4",
    style: {
      transformOrigin: "400.279px 262.033px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4",
    style: {
      transformOrigin: "400.279px 262.033px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-4",
    style: {
      transformOrigin: "424.407px 313.775px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.54 359.77a12 12 0 0 1 6.73 3.81c2.45 3.11 7.89 12.44 9 13.48a7.73 7.73 0 0 1-2.43 2.55l-2.91-3.28c-.72-.6-1.91-2.08-1.88-.15s.27 3.74.56 7.48c.17 2.28 1 6.77-2.89 11.14-3.66 4.09-8.06 6.87-10.79 7.26-1.63.23-5.29-.11-5.11-3.35.1-1.72 2.15-8.24 2.42-11.38s7.3-27.56 7.3-27.56z",
    style: {
      fill: "#263238",
      transformOrigin: "453.542px 380.944px 0"
    },
    id: "elwx4dyf9xh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.21 360.66c-.55-.7-2.27-3.61-3.1-5a186.51 186.51 0 0 1-8.61-19.51c-5.5-14.15-14.79-24.59-17.66-29.91a110.86 110.86 0 0 1-8-18.11l-11.51 7.66-15.14-.28c-.15 2.25.77 5.24 2.46 8.73a.41.41 0 0 1 0 .09c.15.32.32.64.49 1 3.37 6.63 9.13 14.65 15.55 22.75l.15.19c.08.1.15.2.23.29 6.19 7.84 13 15.8 18.93 22.71v-.17c6.38 7.39 11.54 13.39 13.38 16.4 5.38 8.81 4.77 17.43 4.8 22.13 0 2.94 2.31 3.49 5.39.93a18.79 18.79 0 0 0 6.69-14.12c-.02-11.32-.88-11.76-4.05-15.78z",
    style: {
      fill: "#c8856a",
      transformOrigin: "421.217px 340.162px 0"
    },
    id: "elwtvffx58boo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8 213.29c-1 9.14-5.21 20.11-6.82 41.71-1.51 20.26-2.12 30.82-.38 40.8.63 3.56 2.55 7.68 6.14 12.84 11.24 16.17 33.13 41.47 33.13 41.47s4.76-.26 10.36-5.22a16.82 16.82 0 0 0 5.42-11.57s-.69-3.77-10-18.71a82.5 82.5 0 0 1-11-31.42l3.48-65c-13.66 1.81-23.78.15-30.33-4.9z",
    style: {
      fill: "#455a64",
      transformOrigin: "410.597px 281.7px 0"
    },
    id: "el5khgk8rx8hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.23 344.89a16.82 16.82 0 0 0 5.42-11.57s-.69-3.77-10-18.71a82.5 82.5 0 0 1-11-31.42l2.67-49.76c-10.75-1.31-25.66-.61-25.66-.61 0 7.11 1.79 15.84 11.88 20.76 0 0-.62 34.95-.5 45.17.1 7.79 3 27.54 4.35 36.47 7 8.45 12.53 14.89 12.53 14.89s4.71-.26 10.31-5.22z",
    style: {
      fill: "#37474f",
      transformOrigin: "416.655px 291.372px 0"
    },
    id: "el3ldkg8wyp7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.89 380.78a13.19 13.19 0 0 1 3.58 7.38c.37 4.25-.14 15.87.2 17.44a7.35 7.35 0 0 1-3.43.88l-.65-4.67c-.28-1-.18-1.73-1.21 0s-1.87 3.74-3.48 6.31c-1.27 2-3 6.82-8.69 8.49-5.29 1.56-11.45 1-13.94-.25-1.49-.74-4.16-1.91-2.25-4.74 1-1.5 6.8-7.57 8.74-10.25s21.13-20.59 21.13-20.59z",
    style: {
      fill: "#263238",
      transformOrigin: "418.513px 399.17px 0"
    },
    id: "elllz0tpaxf1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5 380.64c.27-11.11-10.19-61.91-7.37-85.77l29.82-.36a130.82 130.82 0 0 0-3.08 21.08c-.48 6.49 1.6 21.35-1.43 37.4a214.51 214.51 0 0 0-3.37 22.68c0 1.72-.18 5.36-.1 6.31.48 5.49-.36 8.61-6.39 17.31-1.16 1.68-4 7.11-12.05 8.16-4 .52-5.59-1.32-4-4 2.47-4.26 7.71-11.7 7.97-22.81z",
    style: {
      fill: "#c8856a",
      transformOrigin: "424.436px 351.024px 0"
    },
    id: "eltk9jdg95il",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.87 315.59c-.06 2.53.09 5 .23 7.56s.23 5 .3 7.56a119.76 119.76 0 0 1-.54 15.15c-.26 2.52-.68 5-1.13 7.49l-1.38 7.41c-.44 2.48-.86 4.95-1.25 7.44s-.79 5-1 7.47a145.6 145.6 0 0 1 1.7-15c.73-5 1.88-9.89 2.33-14.89.3-2.48.45-5 .57-7.5s.13-5 .15-7.54-.05-5-.1-7.56-.11-5.07.12-7.59z",
    style: {
      fill: "#af6152",
      transformOrigin: "434.773px 345.63px 0"
    },
    id: "ele90b6lt1h2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8 213.29s-1.7 11.22 2.37 21.78c3.54 9.17 9.9 14.17 16.48 16.11 0 0-.71 41.81-1.09 47.64s1.7 26.82 3.41 40.63S414.2 358 414.2 358s3 3 11 2.87 10.46-3.65 10.46-3.65 4.52-16.22 4.34-28.79c-.13-7.21-1.78-10.73-.7-17.92s9.7-39.35 10.88-54.51-1.81-28.28-12.74-43.32c-10.91 7.98-36.21 7.63-46.64.61z",
    style: {
      fill: "#455a64",
      transformOrigin: "420.434px 286.777px 0"
    },
    id: "el1fexeuc0rn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 215.21c5.9 7.81 14.58 24 9.65 47.93-1.4 6.8-2.81 13.36-4.17 19.7-3.18 14.86-5.7 26.59-5.94 31.05a36.82 36.82 0 0 0 .61 7.47 64.44 64.44 0 0 1 .62 17.6c-.75 7.62-1.94 15.64-2.81 21.07.34-.1.66-.21.95-.32.87-5.43 2-13.24 2.74-20.66a65.2 65.2 0 0 0-.62-17.82 35.38 35.38 0 0 1-.61-7.3c.24-4.38 2.75-16.08 5.93-30.9 1.36-6.35 2.77-12.91 4.17-19.71 5-24.07-3.7-40.49-9.69-48.48z",
    style: {
      fill: "#37474f",
      transformOrigin: "437.985px 287.435px 0"
    },
    id: "el5quc56w7jzx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.53 210.77s7.39 5 22.31 4.83c16.84-.18 24.71-5.61 24.71-5.61a11.59 11.59 0 0 0 1.73 5.35s-9.53 6-26.27 5.87-22.56-5.15-22.56-5.15a27.35 27.35 0 0 0 .08-5.29z",
    style: {
      fill: "#37474f",
      transformOrigin: "414.865px 215.601px 0"
    },
    id: "el5b6qb6h0esi",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-4",
    style: {
      transformOrigin: "400.06px 183.198px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-4",
    style: {
      transformOrigin: "367.899px 184.704px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-4",
    style: {
      transformOrigin: "374.575px 184.704px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401 160c-5 .79-8.76.82-13.14 7-4.48 6.33-9.64 14.12-16.39 23.83l-16.67-8.41-7.16 11.58s17.84 12.23 24.49 14.7c5 1.85 6.23-.32 10.06-4.09 4.27-4.2 16.85-17.93 16.85-17.93z",
    style: {
      fill: "#c8856a",
      transformOrigin: "374.32px 184.686px 0"
    },
    id: "elye7tzhwwzfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.51 159.59c-6.05.69-9.29 2.06-11.23 3.89s-19.12 26.93-19.12 26.93l-3.16-1.36s2.49 2.81.46 9.4-5 5.67-5 5.67a76.55 76.55 0 0 0 9 5.09c3.27 1.36 5 .45 8.56-2.83s18.72-19.64 18.72-19.64z",
    style: {
      fill: "#f04e30",
      transformOrigin: "382.485px 184.704px 0"
    },
    id: "eljf3fe59414",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.51 159.59c-6.05.69-9.29 2.06-11.23 3.89s-19.12 26.93-19.12 26.93l-3.16-1.36s2.49 2.81.46 9.4-5 5.67-5 5.67a76.55 76.55 0 0 0 9 5.09c3.27 1.36 5 .45 8.56-2.83s18.72-19.64 18.72-19.64z",
    style: {
      opacity: 0.15,
      transformOrigin: "382.485px 184.704px 0"
    },
    className: "animable",
    id: "elc6j5vvx5wuw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.16 190.41c2.83 1.05 6.08 4.24 6.55 5.88-.73-4.56-4.36-6.41-5.71-7.11z",
    style: {
      opacity: 0.35,
      transformOrigin: "374.435px 192.735px 0"
    },
    className: "animable",
    id: "el9zyyz2z1ygh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-4",
    style: {
      transformOrigin: "347.772px 182.904px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m335.59 161.73 1.52-.95a1.54 1.54 0 0 1 1.41.06l13.91 6.16a5.46 5.46 0 0 1 2.82 3.56l5.92 31.91a1.39 1.39 0 0 1-.43 1.52l-1.57 1a1.51 1.51 0 0 1-1.43 0l-13.94-6.17a5.45 5.45 0 0 1-2.8-3.62c-1.17-6.27-4.76-25.64-5.92-31.91-.14-.78.07-1.29.51-1.56z",
    style: {
      fill: "#455a64",
      transformOrigin: "348.141px 182.904px 0"
    },
    id: "el4cqgkgfsx0v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.37 169.06a5.29 5.29 0 0 1 1.35 2.49l5.93 31.89a1.46 1.46 0 0 1-.38 1.5l1.48-.92a1.38 1.38 0 0 0 .43-1.52l-5.92-31.9a5.27 5.27 0 0 0-1.24-2.35z",
    style: {
      fill: "#263238",
      transformOrigin: "356.813px 186.595px 0"
    },
    id: "ely3kpxjm0ezo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.64 203.45-5.92-31.91a5.45 5.45 0 0 0-2.81-3.56L337 161.81c-1.3-.58-2.14.09-1.88 1.48 1.16 6.27 4.76 25.64 5.92 31.91a5.45 5.45 0 0 0 2.81 3.56l13.94 6.17c1.27.58 2.11-.09 1.85-1.48z",
    style: {
      fill: "#37474f",
      transformOrigin: "347.38px 183.37px 0"
    },
    id: "el5477ki84g4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.74 177.9-1.11-6a1 1 0 0 0-.52-.67l-2.62-1.16c-.25-.1-.4 0-.35.28.21 1.18.89 4.8 1.1 6a1.05 1.05 0 0 0 .53.67l2.62 1.16c.24.1.4-.02.35-.28z",
    style: {
      fill: "#455a64",
      transformOrigin: "350.44px 174.124px 0"
    },
    id: "elyb2xqlf6cx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.3 173.26a2.59 2.59 0 0 0-1.36-1.65c-.62-.27-1 0-.92.65a2.55 2.55 0 0 0 1.35 1.65c.63.28 1.04-.01.93-.65z",
    style: {
      fill: "#263238",
      transformOrigin: "350.164px 172.761px 0"
    },
    id: "elew55jpsupf6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.82 176.27a2.57 2.57 0 0 0-1.35-1.65c-.63-.28-1 0-.92.65a2.57 2.57 0 0 0 1.35 1.65c.62.28 1.04-.01.92-.65z",
    style: {
      fill: "#263238",
      transformOrigin: "350.69px 175.769px 0"
    },
    id: "elcm79gwgf6ki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26 180.43c-1.33-2.22-1.17-2.49-.27-3.49a6.63 6.63 0 0 1 5.58-2.31c1.84.21 3.7.32 4.61.89s-.06 2.5-2.5 2.84c-3.85.54-3.91 1.57-3.91 1.57a46.25 46.25 0 0 1 5-.46 33.83 33.83 0 0 1 5.47 1.29c1.57.38 1.72 2.46-1 2.94l2.88.71c2 .49 2.62 1.64.92 2.77a3 3 0 0 1-1.91.54s2.18.18 2.16.91c0 2.08-1.43 2.52-5.93 3.44-4.29.87-5.34 3.06-4.63 4.69 0 0-1.61-1.13-3-2.29-1-.85-1.9-1.78-1.27-3.46 0 0-2.4-.15-2.42-1.64a7.67 7.67 0 0 1 .83-3.13 2.63 2.63 0 0 1-1.12-2.57 4.27 4.27 0 0 1 1.09-2.53z",
    style: {
      fill: "#c8856a",
      transformOrigin: "343.657px 185.684px 0"
    },
    id: "el5zqrtzl9arm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15 183.7a13.91 13.91 0 0 0-2.63-.5 8.58 8.58 0 0 0-2.63.61 30.71 30.71 0 0 0-4.82 2.1 31.07 31.07 0 0 0 5.07-1.37 14 14 0 0 1 2.41-.73c.81-.07 1.73-.01 2.6-.11z",
    style: {
      fill: "#af6152",
      transformOrigin: "343.11px 184.555px 0"
    },
    id: "elkqw5kkebhzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 187.72a6 6 0 0 0-2.86-.32 16.27 16.27 0 0 0-2.8.64 27.4 27.4 0 0 0-5.21 2.27 51.39 51.39 0 0 0 5.44-1.53 15.34 15.34 0 0 1 5.43-1.06z",
    style: {
      fill: "#af6152",
      transformOrigin: "344.565px 188.829px 0"
    },
    id: "elry6agvy1kur",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M446.64 228.36c-4-11.74-6.6-18.52-6.71-22.25 0 0 3.38-18.73 3.87-23.15 1.26-11.49-.8-16.88-3.11-18.1a82.82 82.82 0 0 0-8.57-2.82c-7.95-2.26-19.35-2.55-26.76-2.43-2.78.14-3.63.24-3.63.24a67.94 67.94 0 0 0-10 9.1c-5.88 6.83-7.73 11.42-6.79 18.45a16.85 16.85 0 0 0 3.9 8.27c.46 3.4 1.19 13 1.19 13-.08 3.78.18 3.7-1.73 12.81 6.03 18.01 46.17 16.88 58.34 6.88z",
    style: {
      fill: "#fafafa",
      transformOrigin: "415.674px 197.562px 0"
    },
    id: "elrhtmmijqt99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-4",
    style: {
      transformOrigin: "424.396px 140.108px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.67 112.72a10 10 0 0 1 11.05 2.3c2.75 3 3.39 7.27 3.84 11.3.38 3.44.92 7 1 10.44.06 3 2.14 4.71 4.31 6.7 1.88 1.73 3.75 4 3.46 6.5-.2 1.67-1.34 3.21-1.15 4.89a6.83 6.83 0 0 0 2 3.41c1.54 1.79 3 3.91 2.88 6.27-.17 2.6-2.33 4.65-4.64 5.86-5.88 3.09-12.93 1.85-18.46-1.38s-8.4-9.82-8.8-15.93a52.64 52.64 0 0 1 1.12-12.18 85 85 0 0 1 1.84-8.81c.52-1.83 1.17-3.63 1.59-5.49a23.56 23.56 0 0 0-.27-11.53",
    style: {
      fill: "#263238",
      transformOrigin: "440.105px 142.061px 0"
    },
    id: "el2i7696g99an",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.73 112.65a11.64 11.64 0 0 1 3.86 6.21 3.31 3.31 0 0 1 0 2 2.43 2.43 0 0 1-2.54 1.31 4.83 4.83 0 0 1-2.66-1.42 10.08 10.08 0 0 1-3-5.7c-.16-1-.06-2.6.91-3.22 1.1-.75 2.57.11 3.43.82z",
    style: {
      fill: "#f04e30",
      transformOrigin: "432.536px 116.869px 0"
    },
    id: "el5whwzjqo2a8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14 127.83c-2.33-4.94-.4-11.64 2.12-14.84 3.63-4.62 9.44-6.74 18.3-6.46 6.74.21 14.89 3 16.36 9.83 6.32 3 4.38 11.69 2.82 15.38-3.25 7.75-8 13.88-8 17.94z",
    style: {
      fill: "#263238",
      transformOrigin: "415.193px 128.093px 0"
    },
    id: "el266pwz7hyjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76 117.3c-1.51 1.18-4 4.5-3.62 10.53.2 1.83-.38 4.08-.38 7.5 0 12.9 3.58 15.59 7.07 17.11 2.08.91 3.23 1.06 6.55 1v6s-5 3.95-1.54 14.27c15.66-10.62 20-15.21 20-15.23l.11-16.44c.08.06 2.07 1.81 5.31.05 3.52-1.9 4.89-7.84 2.58-10.56s-6.39-1.5-7.57 1.06c-2 4.32-4.27 2.16-3.47.25-1.65-.78-3.7-2.46-2.2-9.19a7.4 7.4 0 0 0-1.93-6.16c-2.73-2.43-8-1.86-11 1.16-4.16-3.37-6.79-3.8-9.91-1.35z",
    style: {
      fill: "#c8856a",
      transformOrigin: "415.37px 144.726px 0"
    },
    id: "el5v3nb0kl08b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.61 141.26-6 2.1a3 3 0 0 0 3.93 2 3.32 3.32 0 0 0 2.07-4.1z",
    style: {
      fill: "#af6152",
      transformOrigin: "408.683px 143.403px 0"
    },
    id: "elp41twvfaxxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19 145.5a2.84 2.84 0 0 1 2.82-2.82 3 3 0 0 1 .68.09 3.28 3.28 0 0 1-2.12 2.58 3 3 0 0 1-1.38.15z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "409.94px 144.102px 0"
    },
    id: "elc1zvgqmztln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#af6152",
      transformOrigin: "403.56px 133.87px 0"
    },
    id: "elgcialtq3vl5",
    className: "animable",
    d: "m406.84 128.11-.8 11.52-5.76-2.72 6.56-8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38 153.46c4.14-.23 13-2.5 15.14-8 0 0-.32 3.92-5.4 7-4 2.4-9.73 2.9-9.73 2.9z",
    style: {
      fill: "#af6152",
      transformOrigin: "415.95px 150.41px 0"
    },
    id: "elgkbulthrl6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.54 131.74a1.83 1.83 0 1 0 1.65-2 1.83 1.83 0 0 0-1.65 2z",
    style: {
      fill: "#263238",
      transformOrigin: "413.361px 131.562px 0"
    },
    id: "ela9et2jkb6zo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.87 131.28a1.83 1.83 0 1 0 1.37-2.2 1.83 1.83 0 0 0-1.37 2.2z",
    style: {
      fill: "#263238",
      transformOrigin: "399.652px 130.863px 0"
    },
    id: "ela3kvuaqmiw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.56 124.11a2.63 2.63 0 0 1 3.16 1.93l-5.1 1.23a2.63 2.63 0 0 1 1.94-3.16z",
    style: {
      fill: "#263238",
      transformOrigin: "399.135px 125.654px 0"
    },
    id: "elh9kjil8s6dl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.74 125.08a2.62 2.62 0 0 1 1.38 3.44l-4.82-2.05a2.63 2.63 0 0 1 3.44-1.39z",
    style: {
      fill: "#263238",
      transformOrigin: "414.816px 126.696px 0"
    },
    id: "el994i7u1x125",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.89 110.38h19.66c13.27 5.23 8 20.94 5.21 23-7.89-3.32-7-9.83-6.4-14.31-4 3.74-10.66 6.51-13.79 6.83 1.45-1.74 2.67-6.06 2.67-6.06a16.06 16.06 0 0 1-6.22 6.72c-4.86 2.8-8.17.93-8.17.93s-1.65-11.84 7.04-17.11z",
    style: {
      fill: "#263238",
      transformOrigin: "410.451px 121.88px 0"
    },
    id: "elitaq9ajwwrd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.6 157.64a42.16 42.16 0 0 1-1.79 7.4c-1.59 5.12-2.18 9.22-2.49 20.19s3.68 62.24 2.5 74.66c8.16 0 21.16-5.42 27.23-12a139 139 0 0 0-4.41-24.8c-2.91-11.08-5.94-12-5.32-17.91s4.94-29.76.12-41.81a48.76 48.76 0 0 1-7.11-1.42c-7.74-1.87-8.73-4.31-8.73-4.31z",
    style: {
      fill: "#f04e30",
      transformOrigin: "436.176px 208.765px 0"
    },
    id: "elt8bymuvlnfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.6 157.64a42.16 42.16 0 0 1-1.79 7.4c-1.59 5.12-2.18 9.22-2.49 20.19s3.68 62.24 2.5 74.66c8.16 0 21.16-5.42 27.23-12a139 139 0 0 0-4.41-24.8c-2.91-11.08-5.94-12-5.32-17.91s4.94-29.76.12-41.81a48.76 48.76 0 0 1-7.11-1.42c-7.74-1.87-8.73-4.31-8.73-4.31z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "436.176px 208.765px 0"
    },
    className: "animable",
    id: "eli6k9kf5qsbr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.23 157.06-.29 1.1c0 3.14-6.48 8.15-11 15.56s-5.26 14.65-4.95 24.12a132.6 132.6 0 0 1-1.22 20c-2 12.31-5.75 24-6.21 30.87 0 0 1.09-10.45 1.53-16.83.49-7.21 2.45-16.15 2.45-23.16 0-5.61-.25-11.61-.25-11.61a19.62 19.62 0 0 1-3.56-17.22c2.63-10.33 16.77-20.37 16.77-20.37a26.19 26.19 0 0 1 2.77-.68 15.52 15.52 0 0 0 3.96-1.78z",
    style: {
      fill: "#f04e30",
      transformOrigin: "396.148px 202.885px 0"
    },
    id: "elmcd84w00le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.23 157.06-.29 1.1c0 3.14-6.48 8.15-11 15.56s-5.26 14.65-4.95 24.12a132.6 132.6 0 0 1-1.22 20c-2 12.31-5.75 24-6.21 30.87 0 0 1.09-10.45 1.53-16.83.49-7.21 2.45-16.15 2.45-23.16 0-5.61-.25-11.61-.25-11.61a19.62 19.62 0 0 1-3.56-17.22c2.63-10.33 16.77-20.37 16.77-20.37a26.19 26.19 0 0 1 2.77-.68 15.52 15.52 0 0 0 3.96-1.78z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "396.148px 202.885px 0"
    },
    className: "animable",
    id: "elzp3z2eus9pl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.79 153.24a15.71 15.71 0 0 0 5 8s-2.13 10-1.76 14.86 1.37 9.63 0 9.6a37.15 37.15 0 0 1-5.43-1.28s3.26 4.77 2.95 6.26-5.37 18.3-5.37 18.3-2.12-19.44-1.79-25.14 1.36-16.16 3.39-22.15c1.45-4.2 3.01-8.45 3.01-8.45z",
    style: {
      fill: "#f04e30",
      transformOrigin: "426.073px 181.11px 0"
    },
    id: "elj1e18glhgnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.82 206.29c-.28-5.47-3.14-19.19-3.51-21.94s3.51-5.23 3.51-5.23-2.34.6-3.11 0 3.94-7.44 8-12 11.71-11.35 11.71-11.35v3.62a50.59 50.59 0 0 0-5.88 7.73c-3.54 5.88-10.12 12.17-10.72 39.17z",
    style: {
      fill: "#f04e30",
      transformOrigin: "398.353px 181.03px 0"
    },
    id: "elm7vihbco3cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-4",
    style: {
      transformOrigin: "433.933px 194.362px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.13 185.9c-2.89-2.51-4.36-3.51-5.75-4s-6.24-3-8.13-3.59c-1.19-.39-1.83 1.51-.38 3 1.12 1.12 4.12 2.69 5.42 3.54s3.73 4.29 3.73 4.29z",
    style: {
      fill: "#af6152",
      transformOrigin: "409.582px 183.699px 0"
    },
    id: "elzwx0n3d5cb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.81 174.63c-2.68-7.54-6.92-10.23-14.22-11-4.56 10.45-1 27-1 27l4.24 12s-14.72-4.85-16.68-6.33a98.34 98.34 0 0 1-8.6-8.39c-2.35-2.62-3.63-2.39-4.94-2.29-4.26.32-5.21.6-6.15 1.1a1.92 1.92 0 0 0-.94 1.58c-1.13.06-2.8-.1-3.16 1.72a5 5 0 0 0-.17 1.47 1.22 1.22 0 0 0-.76.36c-1 1 .3 4.87 1.25 5.85a3.63 3.63 0 0 0 3 .77c1.15-.07.71-1.26.71-1.26l1.58.21c3.24 2.7 3.05 7.54 7.51 8.94a31.69 31.69 0 0 1 5.45 1.49c9.52 4 22 16 32.81 16.79 8.52.6 9.6-3.39 9.65-8.6.1-5.44-7.2-34.68-9.58-41.41z",
    style: {
      fill: "#c8856a",
      transformOrigin: "434.23px 194.165px 0"
    },
    id: "el1j7w0pm2nfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.45 163.38c4.12.71 7.88 1 11 4.39s3.93 6.49 6.12 14.7 4.29 16.6 6 24.83 1.88 13.29-.73 15.94-7.59 2.22-10.13 1.76a40.07 40.07 0 0 1-7.22-2.76s2.43-3.35 1.41-10.33-4.68-9.85-4.68-9.85l1.43.41-5.32-13.47c-2.17-5.5-1.46-20.84 2.12-25.62z",
    style: {
      fill: "#f04e30",
      transformOrigin: "451.968px 194.362px 0"
    },
    id: "elbghioulq2b6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.45 163.38c4.12.71 7.88 1 11 4.39s3.93 6.49 6.12 14.7 4.29 16.6 6 24.83 1.88 13.29-.73 15.94-7.59 2.22-10.13 1.76a40.07 40.07 0 0 1-7.22-2.76s2.43-3.35 1.41-10.33-4.68-9.85-4.68-9.85l1.43.41-5.32-13.47c-2.17-5.5-1.46-20.84 2.12-25.62z",
    style: {
      opacity: 0.15,
      transformOrigin: "451.968px 194.362px 0"
    },
    className: "animable",
    id: "el57cekrxlixw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.74 200.18.89 2.29c5 1.22 10.14 2.57 11.5 4.44-1.42-3.13-5.31-5.3-12.39-6.73z",
    style: {
      opacity: 0.35,
      transformOrigin: "449.935px 203.545px 0"
    },
    className: "animable",
    id: "el2dgesylwx05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.55 188.28 5.08-.63-4.92-.05a1.92 1.92 0 0 0-.16.68z",
    style: {
      fill: "#af6152",
      transformOrigin: "410.09px 187.94px 0"
    },
    id: "eliomegj80oqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.22 191.47 5.82-.32-5.78-.35a2.91 2.91 0 0 0-.04.67z",
    style: {
      fill: "#af6152",
      transformOrigin: "407.128px 191.135px 0"
    },
    id: "elxcyg2e2z0v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 196.39a2.26 2.26 0 0 1-.63-1.17 20.19 20.19 0 0 1-2-.28 7.61 7.61 0 0 1-.75-.28 2.11 2.11 0 0 1-.79-.6 1.83 1.83 0 0 0 .72.74 4.2 4.2 0 0 0 .84.37l.28.73a1.24 1.24 0 0 0-.62.18 1.58 1.58 0 0 0-.56.72 1.77 1.77 0 0 1 .64-.58 1.12 1.12 0 0 1 .78-.09 2.51 2.51 0 0 1 1.57 1.06l1.58.21a11.07 11.07 0 0 1-1.06-1.01z",
    style: {
      fill: "#af6152",
      transformOrigin: "407.445px 195.73px 0"
    },
    id: "ely02nhpg311",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4",
    style: {
      transformOrigin: "103.554px 265.3px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-4",
    style: {
      transformOrigin: "103.554px 265.3px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-4",
    style: {
      transformOrigin: "86.8344px 328.115px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.06 353.46c-.4 11.38-.58 22.45-.41 29.13 0 .62-5.53 3.42-9.76 2.7s-5.34-2.21-5.34-2.66c0-1.53-1.06-2.92-1.21-4.45-1-9.88-1.91-17.83-3.08-24.72z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "102.16px 369.434px 0"
    },
    id: "elxecb61uf3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.65 358.56 64 356.94c-2 9.62-4.15 19.61-5.69 26.35a37.72 37.72 0 0 1-1.74 6c-.92 4.35-11.37 4.87-13.45-2.08l.45-5.92c.22-5.5.71-14.58 1.08-22.73z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "53.56px 374.724px 0"
    },
    id: "elvpmy6m29ld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3 401.93c.28 0 .7 2.94-.8 4.2-1.74 1.45-6.84 3.86-13.59 3.06s-8.62-2.08-11.32-4.24-5.18-4.42-8.24-5.05c-2.83-.58-7.14-1.65-8-2.49s-.79-4.58-.79-4.58z",
    style: {
      fill: "#263238",
      transformOrigin: "114.067px 401.089px 0"
    },
    id: "elm7fm2ex14fp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.08 376.57a1.21 1.21 0 0 0-1.14.9c-.21 1-.43 4-.87 5.73a41.11 41.11 0 0 0-.43 10.92c.37 1.92 6.23 3.07 9.18 4.13a28.23 28.23 0 0 1 8.27 5 21.15 21.15 0 0 0 12.46 4.31c5.2-.07 11-1.73 12.39-4.06 1.66-2.88 1.9-5.64-5.81-9-1.46-.64-6-3.15-7.71-4.2a32.88 32.88 0 0 1-5.37-3.9 25.89 25.89 0 0 1-2-1.94 6.19 6.19 0 0 1-1.07-2.09c-.46-1.36-.27-2.85-.51-4.26a.78.78 0 0 0-.13-.37.87.87 0 0 0-.35-.2 9.43 9.43 0 0 0-3.78-.16 15.59 15.59 0 0 0-3.8.85 3.11 3.11 0 0 0-1.74 1.09 2.54 2.54 0 0 0-.35 1.38 8.63 8.63 0 0 1 0 1.44.79.79 0 0 1-.2.48c-.26.25-.68.05-.9-.14a19 19 0 0 1-2.1-2.48c-.37-.43-2-.7-2.46-1a11.7 11.7 0 0 1-1.32-.82c-.47-.44-.24-1.02-.26-1.61z",
    style: {
      fill: "#37474f",
      transformOrigin: "114.172px 392.065px 0"
    },
    id: "elmymomoxlysl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.09 403.23a39 39 0 0 0-3.58-2.62s8.22 3.08 11.88.64c2.36-1.56 1.23-3.44 1.17-4.05s5.77-3.22 8.06-3.49c.64.33 1.17.6 1.51.75 7.71 3.39 7.47 6.15 5.81 9-1.34 2.33-5.57 4.17-12.3 4.21a21.76 21.76 0 0 1-12.55-4.44z",
    style: {
      fill: "#455a64",
      transformOrigin: "121.197px 400.69px 0"
    },
    id: "ell3i789c23zs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.93 395.44c4.79 1.82 2.75 2.69 1.41 2.89s-8.11-3.52-13-7.24c-5.14-3.87-9.62-8-11.53-9.4a32.35 32.35 0 0 1-2.15-1.79c.12-1 .22-1.95.32-2.43.17-.87 1.24-1.13 1.24-1.13l.16 1.84a3.46 3.46 0 0 0 1.4.68 6.27 6.27 0 0 1 2.34 1.14 19 19 0 0 0 2.08 2.39c4.19 5.13 12.93 11.24 17.73 13.05z",
    style: {
      fill: "#263238",
      transformOrigin: "107.8px 387.339px 0"
    },
    id: "el13b59nsi5xlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 397.65a.45.45 0 0 1-.3-.1.43.43 0 0 1-.07-.64 11.68 11.68 0 0 1 8.78-3.4.46.46 0 0 1 .42.5.47.47 0 0 1-.52.41 10.84 10.84 0 0 0-8 3.06.48.48 0 0 1-.31.17z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "124.175px 395.574px 0"
    },
    id: "el4krdmbxmn25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8 395.4a.43.43 0 0 1-.3-.09.44.44 0 0 1-.08-.64 11.73 11.73 0 0 1 8.69-3.59.46.46 0 0 1 .44.49.47.47 0 0 1-.51.42 10.81 10.81 0 0 0-7.87 3.24.48.48 0 0 1-.37.17z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "119.934px 393.239px 0"
    },
    id: "elai9u07u034p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.93 392.84a.47.47 0 0 1-.3-.1.45.45 0 0 1-.07-.64 11.71 11.71 0 0 1 8.78-3.39.45.45 0 0 1 .42.5.47.47 0 0 1-.52.41 10.83 10.83 0 0 0-7.94 3.05.5.5 0 0 1-.37.17z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "116.11px 390.769px 0"
    },
    id: "el84gx3h4fd43",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51 390.53a.46.46 0 0 1-.3-.09.44.44 0 0 1-.1-.64 11.69 11.69 0 0 1 8.62-3.75.46.46 0 1 1-.06.92 10.79 10.79 0 0 0-7.8 3.37.48.48 0 0 1-.36.19z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "112.588px 388.29px 0"
    },
    id: "elbb5pmfjehvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83 387.8a.55.55 0 0 1-.3-.09.44.44 0 0 1-.1-.64c1.76-2.34 5.9-4 9.44-3.79a.46.46 0 0 1 .44.49.47.47 0 0 1-.5.43c-3.19-.2-7 1.33-8.62 3.41a.48.48 0 0 1-.36.19z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "109.323px 385.531px 0"
    },
    id: "ela4m48lw393m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41 412.91c-.33 4.49-1.07 7.46-2.7 10.07s-4.64 3.4-7.68 2.58-6.9-2.93-7.72-6.81-.61-6.54.14-10.7z",
    style: {
      fill: "#263238",
      transformOrigin: "47.097px 416.96px 0"
    },
    id: "elbex87g67d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.53 381.25c-1.07.32-1.42 6.47-2.22 12.49-.87 6.47-2 8.4-2.8 13.7-.88 6.05-.48 8.09 1.59 11.78s9.55 7.4 13.33 2.2c3.08-4.24 3.15-8.31 3-14.36a126.71 126.71 0 0 1 .24-14.43c.31-4.53 2.72-8.82 1.64-9.34.2.1-.72 3.14-.8 3.4a5.93 5.93 0 0 1-.68 1.67c-.6.84-.87-.55-.86-1.07 0-.9.32-1.61-.37-2.36a5.16 5.16 0 0 0-1.86-1.1 12.12 12.12 0 0 0-2.27-.69 24.48 24.48 0 0 0-4.84-.33 2.32 2.32 0 0 0-1.88.75 1.33 1.33 0 0 0-.18.48c-.13.59-.07 1.2-.2 1.79 0 .17-.11.6-.27.69s-.42.06-.43-.06-.27-4.16-.14-5.21z",
    style: {
      fill: "#37474f",
      transformOrigin: "48.3288px 402.619px 0"
    },
    id: "el5dojo72i56w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.79 405.37c-.13.87-.81 6.32.75 7.39s2.69-3.39 2.69-3.39 4-1.17 9.81 1.46c-.31.94.55 4.05 2.16 3.42s2.19-6.58 2.2-6.67c.17 5.81 0 9.72-3 13.84-3.78 5.2-11.25 1.5-13.33-2.2s-2.47-5.73-1.59-11.78c.12-.6.2-1.52.31-2.07z",
    style: {
      fill: "#455a64",
      transformOrigin: "47.242px 414.681px 0"
    },
    id: "elklvnpgnq08h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.68 409.77c0 2.19-2 1.41-2.26-1.68-.38-4.62.83-9 .89-14.34.8-6 1-12.42 2.22-12.5-.06 1.05.1 5.21.1 5.21-.45 4.51-1.71 9.78-1.59 14.44.1 4.1.7 6.68.64 8.87z",
    style: {
      fill: "#263238",
      transformOrigin: "41.9881px 396.133px 0"
    },
    id: "el8c4w0mlbi1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.37 410.76c.44-2.14 1.15-2.75 1.64-6.82s2.84-11.36 3.76-15.76c.25-1.37 1.49-4.84 1.5-4.89.78.39 0 2.92-.66 5.64s-1.09 4.39-1.52 7c-1.15 5.2-1.38 10.74-2.13 13.75s-3.03 3.23-2.59 1.08z",
    style: {
      fill: "#263238",
      transformOrigin: "54.9551px 397.738px 0"
    },
    id: "elrc8ezns9i3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.86 410.88-.16-.05a14.79 14.79 0 0 0-9.65-1.14.47.47 0 0 1-.57-.34.46.46 0 0 1 .34-.56A15.5 15.5 0 0 1 52.14 410a.47.47 0 0 1 .19.63.48.48 0 0 1-.47.25z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "46.9249px 409.641px 0"
    },
    id: "el0jxbw41jgks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.19 406.54a.42.42 0 0 1-.15 0s-5.6-2.67-11.26-1.44a.47.47 0 1 1-.2-.91 20.39 20.39 0 0 1 11.87 1.51.48.48 0 0 1 .21.63.46.46 0 0 1-.47.21z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "47.4277px 405.219px 0"
    },
    id: "elo8fw40oxgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.18 401.49a.46.46 0 0 1-.09-.9c5.65-1.83 13 .91 13.24 1a.47.47 0 1 1-.44.82s-7.25-2.67-12.51-1a.45.45 0 0 1-.2.08z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "47.6986px 401.231px 0"
    },
    id: "elle6kjeq4eu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.15 397.58a.48.48 0 0 1-.39-.31.47.47 0 0 1 .29-.59c6.22-2.13 12.52 1.34 12.74 1.48a.46.46 0 1 1-.49.79s-6.16-3.37-11.95-1.39a.47.47 0 0 1-.2.02z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "48.3731px 397.505px 0"
    },
    id: "eluq3gfj3pje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 392.8a.47.47 0 0 1-.11-.9c5.83-2.09 12.59 1.47 12.82 1.61a.46.46 0 1 1-.47.8c-.06 0-6.62-3.48-12-1.54a.4.4 0 0 1-.24.03z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "48.8685px 392.809px 0"
    },
    id: "el60xvbixoufj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84 281.06 4.79 29a91.45 91.45 0 0 0-1 17.05c.42 8.38 4.18 32.62 6 41.51a18.53 18.53 0 0 0 18.18.43s1.83-48.88 2.57-60.63-1-59.42-1.59-78.06l-57.15.18s-1.13 10-2.14 25-3.35 55.11-3.35 55.11c-6.19 17.81-5.61 29.5-6.7 62.78a17.27 17.27 0 0 0 16.94 2s9-32.69 12.47-45.95c1.65-6.32 7.66-33.83 11-48.43",
    style: {
      fill: "#455a64",
      transformOrigin: "79.1651px 303.573px 0"
    },
    id: "elzdkvddi7x5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.83 259.47 1.64 22.86c.1 3.65.92 11.64 1 15.29s.18 7.3 0 10.9-1.91 33.2-1.63 40.53c1.09-8.12 2.87-33.11 3.32-40.46.18-7.39-.67-15.75-1.64-26.36s-1.77-15.5-2.69-22.76z",
    style: {
      fill: "#37474f",
      transformOrigin: "110.007px 304.26px 0"
    },
    id: "elrfalftpsmz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 255.56c-2.86 12-7.57 43-8.64 51.26s-9 41-9.78 49.33C57 347.88 65.83 315.38 67 307s5.16-36.26 7-51.44z",
    style: {
      fill: "#37474f",
      transformOrigin: "64.79px 305.855px 0"
    },
    id: "eljzdjo3z7use",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.87 258.36 84 281.06l4.79 29-2-24.28L92.11 261s10-3 12.59-13.12c-5.09 8.12-15.83 10.48-15.83 10.48z",
    style: {
      fill: "#37474f",
      transformOrigin: "94.35px 278.97px 0"
    },
    id: "elgdon7dladr9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-4",
    style: {
      transformOrigin: "103.554px 199.534px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-4",
    style: {
      transformOrigin: "137.273px 200.901px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-4",
    style: {
      transformOrigin: "137.921px 201.086px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.23 207c1.78 3.44 3 4.66 5.44 5.91 1.6.85 3.74 1.86 10.36 4.85a119.18 119.18 0 0 1 13.07 6.48 13.47 13.47 0 0 1 5.15 5.59 32.74 32.74 0 0 0 4.05 6.09 25.62 25.62 0 0 0 5.34 4.94 4.12 4.12 0 0 0 2.23.88.85.85 0 0 0 .79-.45 2.71 2.71 0 0 0 .13-1c1 .58 1.6 1 3.1 1.82a3.62 3.62 0 0 0 2.31.53 1 1 0 0 0 .7-.86 13 13 0 0 0 1.62.91 2.54 2.54 0 0 0 1.34.28.94.94 0 0 0 .65-.23 1.4 1.4 0 0 0 .3-1 4 4 0 0 0-1.07-2.32l1.24.45c.58.21 1.86.74 2.33.09s0-1.38-.29-1.88a10.25 10.25 0 0 0-2.9-2.78c-1.12-.82-2.29-1.56-3.34-2.45a11.67 11.67 0 0 1-1.89-2.46 16.51 16.51 0 0 1-1.7-3.15c-.2-.5-.73-2.12.12-1.6 1.11.69 2.66 2 3.81 2.58a4.9 4.9 0 0 0 3.74.4 1.62 1.62 0 0 0 .83-.8c.2-.52-.09-.76-.44-1a10.15 10.15 0 0 1-1-.95l-2.06-2c-4-3.9-5.37-5.6-10.94-7a29.62 29.62 0 0 1-6.25-2.49c-2.62-1.44-22.15-14.89-22.15-14.89l-8.86-21c-3.07-7.27-6.39-17.85-16.85-19.43 0 0-6.79 10.72 0 25.35 3.93 8.5 8.34 17.25 11.09 22.59z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "137.816px 201.018px 0"
    },
    id: "elljmflqq7p1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 217.73c3.15 1.4 6.31 2.78 9.39 4.33a41.73 41.73 0 0 1 4.51 2.55 13.06 13.06 0 0 1 3.62 3.71c.48.72.86 1.51 1.27 2.25s.87 1.49 1.34 2.2a35.34 35.34 0 0 0 3.16 4.06 27.54 27.54 0 0 0 3.82 3.41 5.75 5.75 0 0 0 2.18 1.21 1.11 1.11 0 0 0 1.05-.11c.23-.2.23-.68.22-1.09a.19.19 0 0 1 .19-.19.19.19 0 0 1 .1 0l3.11 1.8a4.26 4.26 0 0 0 1.61.54.87.87 0 0 0 1.09-.7.21.21 0 0 1 .22-.2.29.29 0 0 1 .1 0 14 14 0 0 0 1.64.91 3 3 0 0 0 .85.24 1.6 1.6 0 0 0 .79-.11.91.91 0 0 0 .29-.67 1.89 1.89 0 0 0-.11-.85 5.45 5.45 0 0 0-.91-1.58.24.24 0 0 1 0-.33.22.22 0 0 1 .22 0l1.7.62c.53.18 1.19.35 1.52.09s.21-.91 0-1.41a5.34 5.34 0 0 0-1-1.39c-1.68-1.68-3.89-2.77-5.69-4.47a10.31 10.31 0 0 1-1.11-1.47c-.32-.51-.67-1-1-1.53a12.17 12.17 0 0 1-1.47-3.36 2.67 2.67 0 0 1 0-.5.48.48 0 0 1 .13-.32.39.39 0 0 1 .39-.07 5.13 5.13 0 0 1 .81.51l1.47 1.06a7.88 7.88 0 0 0 3.14 1.6 4.65 4.65 0 0 0 1.74.07 1.59 1.59 0 0 0 1.23-1 .55.55 0 0 0-.26-.63c-.23-.17-.45-.41-.68-.61-.45-.42-.88-.84-1.31-1.27l-2.58-2.53c-.87-.85-1.73-1.69-2.65-2.46a15.93 15.93 0 0 0-6.4-3.18 30 30 0 0 1-6.72-2.68 30.12 30.12 0 0 0 6.75 2.57 16.08 16.08 0 0 1 6.52 3.11c.94.77 1.81 1.61 2.68 2.45l2.6 2.53c.43.42.86.84 1.3 1.24.23.2.42.42.67.6a1.31 1.31 0 0 1 .33.4.78.78 0 0 1 0 .54 1.48 1.48 0 0 1-.58.8 2.33 2.33 0 0 1-.88.39 4.84 4.84 0 0 1-1.86-.06 8.15 8.15 0 0 1-3.27-1.64l-1.48-1a5.52 5.52 0 0 0-.72-.45c-.05 0-.06 0 0 0a.66.66 0 0 0 0 .09 2 2 0 0 0 0 .41 12.17 12.17 0 0 0 1.44 3.24c.31.5.66 1 1 1.5a9.65 9.65 0 0 0 1.08 1.42c1.72 1.61 4 2.7 5.72 4.43a6 6 0 0 1 1.11 1.51 2.59 2.59 0 0 1 .29.94 1.15 1.15 0 0 1-.36 1 1.39 1.39 0 0 1-1 .22 4.59 4.59 0 0 1-.92-.23c-.58-.2-1.14-.41-1.71-.63l.27-.36a6.2 6.2 0 0 1 1 1.72 2.61 2.61 0 0 1 .12 1 1.29 1.29 0 0 1-.49 1 2.38 2.38 0 0 1-2.06-.09 14.43 14.43 0 0 1-1.69-.94l.32-.17a1.18 1.18 0 0 1-.55.9 1.5 1.5 0 0 1-1 .18 4.77 4.77 0 0 1-1.77-.6l-3.1-1.82.29-.17a1.85 1.85 0 0 1-.35 1.37 1.17 1.17 0 0 1-.71.28 2.61 2.61 0 0 1-.69-.09 6.07 6.07 0 0 1-2.3-1.29 28.22 28.22 0 0 1-3.86-3.47 37.06 37.06 0 0 1-3.16-4.11c-.47-.73-.92-1.47-1.33-2.23s-.79-1.53-1.26-2.25a13 13 0 0 0-3.53-3.66 45.68 45.68 0 0 0-4.45-2.59c-3.13-1.55-6.26-2.99-9.42-4.44z",
    style: {
      fill: "#f0997a",
      transformOrigin: "152.86px 228.646px 0"
    },
    id: "elwxxlf4e9wpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.49 226.12a11.58 11.58 0 0 1-10.26-2.9 7.79 7.79 0 0 0 4.21 3.37 7.38 7.38 0 0 0 6.05-.47z",
    style: {
      fill: "#f0997a",
      transformOrigin: "157.36px 225.124px 0"
    },
    id: "elm95b69d4zz",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166 235.36a23.39 23.39 0 0 1-2.17-2.17c-.69-.77-1.36-1.56-2-2.34a24.36 24.36 0 0 0 1.76 2.57 15 15 0 0 0 2.15 2.29 28 28 0 0 0 2.52 1.84c.86.57 1.7 1.17 2.52 1.81a44.9 44.9 0 0 0-4.78-4zm.15 3.59c-.91-.68-1.77-1.39-2.67-2.07a24.28 24.28 0 0 1-2.49-2.27l-2.4-2.41a34.07 34.07 0 0 0 2.15 2.65 17.25 17.25 0 0 0 2.45 2.38c.91.68 1.81 1.4 2.76 2a3.52 3.52 0 0 1 2 2.53 2.38 2.38 0 0 0-.5-1.63 6.76 6.76 0 0 0-1.31-1.13zm-5.4-.69c-.55-.53-1.11-1-1.63-1.52l-1.59-1.55c-.52-.53-1.05-1-1.53-1.62a9 9 0 0 0 1.28 1.85 19.8 19.8 0 0 0 1.53 1.65 17.74 17.74 0 0 0 1.71 1.45 3.59 3.59 0 0 1 1.28 1.73 3.67 3.67 0 0 0-.32-1.09 4.56 4.56 0 0 0-.74-.9z",
    style: {
      fill: "#f0997a",
      transformOrigin: "163.39px 236.305px 0"
    },
    id: "el8y71ck1l6gh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.29 192.93 1.53 3.54a18.73 18.73 0 0 1-7.36 5.91 19.43 19.43 0 0 1-7.93 1.83l-2-3.94a27.66 27.66 0 0 0 8.64-2.11c5.3-2.05 7.12-5.23 7.12-5.23z",
    style: {
      fill: "#263238",
      transformOrigin: "120.175px 198.57px 0"
    },
    id: "elk8l2sxelh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12 158.69c4.16.75 9.15 1.18 13 8.85 4.64 9.32 8.62 18.62 9.71 20.36s1.5 3.36.4 5.19-6.91 7.84-15.12 7.4c-3-.64-3.35-1.77-4.35-4.55-.51-1.43-2.54-5.81-4.12-9.37a40.15 40.15 0 0 1-3.81-17.68c.11-4.26 2.01-8.59 4.29-10.2z",
    style: {
      fill: "#37474f",
      transformOrigin: "113.852px 179.601px 0"
    },
    id: "el9c108zigfan",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-4",
    style: {
      transformOrigin: "82.6368px 201.15px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-4",
    d: "M73.76 155.61a191.76 191.76 0 0 0-20.94 8s-2.61 9.41 1.62 32.62a121.13 121.13 0 0 1 1.37 21.26c-.14 6.4-.7 16.62-.86 21 0 0 10.19 10.19 35 7.85 19.45-1.85 23.3-8.95 23.3-8.95s-.66-30.57-.66-45.41c0-23.69-3.15-29.12-8.44-33.33-.69-.42-13.86-2.61-13.86-2.61z",
    style: {
      fill: "#263238",
      transformOrigin: "82.6368px 201.15px 0"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-4",
    style: {
      transformOrigin: "46.5802px 221.587px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-4",
    style: {
      transformOrigin: "45.9048px 221.857px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.35 261c-2.57-2.79-3.2-7.06-6-9.66-.85-.8-1.86-1.39-2.75-2.14a3.24 3.24 0 0 1-1.35-2.76c0-.6 1.21-28.6 1.21-28.6s4.24-16.27 7.67-25.09c2.39-15.47 1-26.88-3.43-29.12-7.42 2.83-9.69 5.41-11.52 10.64-1.19 3.39-2.62 8.45-4.37 15.51-2.72 10.93-3.37 13.4-5.07 21.31-.72 3.35-.2 7.28.32 13.73.7 8.64 2.1 22.51 2.25 23.75.49 4 .09 9.8 1 12.07s2 5.08 2.91 6.84a4.33 4.33 0 0 0 2.65 2.18 31.57 31.57 0 0 0 3.35 4.73 3.14 3.14 0 0 0 3.11 1 33 33 0 0 0 3 3.23c2.14 2.11 2.34 1.45 2.74 1a2.52 2.52 0 0 0 .22-2.83c-.71-1.12-3-3.37-3.54-4.26a19.37 19.37 0 0 1-1.34-3.22s.65.89 1.26 1.79a34.72 34.72 0 0 0 3.33 3.22c1.62 1.55 2.93 2.38 3.53 1.8s.62-2-.17-3.24-4.15-4.25-4.58-5.58a28.47 28.47 0 0 1-1.63-5.3c-.14-.64-1-3.36.67-2.6a2.47 2.47 0 0 1 .87.86 9.74 9.74 0 0 0 2.55 2.57 4.3 4.3 0 0 0 3.47.63 1.09 1.09 0 0 0 .49-.25 1 1 0 0 0 .1-1.11 3.56 3.56 0 0 0-.75-.9z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "45.9048px 221.857px 0"
    },
    id: "elnfwi7z5cfjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.29 275.35a20.52 20.52 0 0 1-3.09-4.66 24.63 24.63 0 0 1-1.91-5.25c.7 1.72 1.4 3.44 2.24 5.09a41.92 41.92 0 0 0 2.76 4.82z",
    style: {
      fill: "#f0997a",
      transformOrigin: "45.79px 270.395px 0"
    },
    id: "elqu54ohjbftf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83 269.67a10.08 10.08 0 0 1-1.46-2.39 13.55 13.55 0 0 1-.86-2.66c.46.83.81 1.68 1.2 2.51z",
    style: {
      fill: "#f0997a",
      transformOrigin: "40.67px 267.145px 0"
    },
    id: "el8e3otvov9r8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36 269.28a25.39 25.39 0 0 1-2.36-4.21 10.17 10.17 0 0 0 2.91 5.73z",
    style: {
      fill: "#f0997a",
      transformOrigin: "48.455px 267.935px 0"
    },
    id: "elr530xumh9a",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.12 163.09c-3.15.9-9.33 1.8-12.39 10.87s-6.87 21.74-7.42 23.72a3.35 3.35 0 0 0 .67 3.59c.71 1.06 4.06 3.1 8.5 4.41a20.23 20.23 0 0 0 9.16.8 4.8 4.8 0 0 0 2.69-3.08c.69-1.81 2.2-6.11 3.33-9.45 1.34-4.08 5.81-23.83-4.54-30.86z",
    style: {
      fill: "#37474f",
      transformOrigin: "47.4148px 184.887px 0"
    },
    id: "elps3i9934v6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 201.27-.9 3.47s1.18 2.54 8 4.38 9.77.66 9.77.66l1-3.37A26.6 26.6 0 0 1 43.2 205c-5.72-1.77-8.2-3.73-8.2-3.73z",
    style: {
      fill: "#263238",
      transformOrigin: "43.485px 205.711px 0"
    },
    id: "elcha2nkwgwm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-4",
    style: {
      transformOrigin: "82.907px 138.155px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.45 107.33c-9.63-1.4-16 2.82-19.58 8.07-4 .36-6 3.7-6.29 7.67-.92 13.39 10.24 19.5 12.38 25.86l29.28-25.81c.21-4.77-3.1-13.96-15.79-15.79z",
    style: {
      fill: "#37474f",
      transformOrigin: "81.3877px 127.994px 0"
    },
    id: "elncdhjjl9ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.8 113.79 5.39 1.67a3 3 0 0 1-3.65 1.84 2.68 2.68 0 0 1-1.74-3.51z",
    style: {
      fill: "#37474f",
      transformOrigin: "64.4094px 115.605px 0"
    },
    id: "elpk58b5afp9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 110.15 1.21 5.4a3 3 0 0 1-3.45-2.18 2.69 2.69 0 0 1 2.24-3.22z",
    style: {
      fill: "#37474f",
      transformOrigin: "65.4557px 112.876px 0"
    },
    id: "els65yx26jj9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1 115.06c3.54-5.24 9.72-9.13 19.35-7.73 12.69 1.83 16 11 15.79 15.79l-6.34 5.43-12.33-8.63c-1.92-3.13-12.57-5.57-16.47-4.86z",
    style: {
      fill: "#263238",
      transformOrigin: "84.6746px 117.796px 0"
    },
    id: "elujz8ypp2pq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57 119.92c-1.28-.88-3.08-1.25-5.36.48a6.82 6.82 0 0 0-2.2 3.28c-.54 1.73-.52 2.36-.63 5.15-.08 1.91-.91 6.38-4 5.12-.92-.37-1.43-1.27-2.24-1.77-2.52-1.58-5.93-.87-7 1.95a7.12 7.12 0 0 0 3.34 9c4.26 1.9 5.71-.5 5.71-.5l.07 15.08c2.93 4.61 10.13 9.31 20.61 13.87 2.36-3.94.89-11.29-1.62-13.77v-5.85a19 19 0 0 0 5.5-.84c4.06-1.37 5.76-5.21 6.38-9.12.72-4.46.2-11.57-.37-16.19A31.39 31.39 0 0 0 101 122c-3.5-4.37-14.71-7.4-17.43-2.08z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "82.0502px 144.334px 0"
    },
    id: "ellnqy2y5o7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0997a",
      transformOrigin: "93.35px 133.03px 0"
    },
    id: "el8eghzo1sy85",
    className: "animable",
    d: "m89.63 127.62 2.13 10.82 5.31-2.5-7.44-8.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.06 140.09 5.84 1.67a3 3 0 0 1-3.72 2.12 3.11 3.11 0 0 1-2.12-3.79z",
    style: {
      fill: "#b16668",
      transformOrigin: "88.9262px 142.042px 0"
    },
    id: "el4l2z2ncilqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18 143.88a2.2 2.2 0 0 0 .37.06 2.72 2.72 0 0 0-2.58-2.8 3.08 3.08 0 0 0 2.21 2.74z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "87.2607px 142.54px 0"
    },
    id: "elaexovdtvi7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.76 128a4.38 4.38 0 0 1 1.3-.5 3.9 3.9 0 0 1 1.36-.11 4.31 4.31 0 0 1 1.39.36s.06.11 0 .11a12.09 12.09 0 0 0-1.24-.09 3.13 3.13 0 0 0-.42 0 1.84 1.84 0 0 1 .74.88c.36.92-.3 1.24-1.2 1.58s-1.72.54-2.07-.37a1.72 1.72 0 0 1 0-1.39l-.31.16c-.17.09-.51.28-.54.31s-.1-.09-.08-.14a3 3 0 0 1 1.07-.8z",
    style: {
      fill: "#263238",
      transformOrigin: "97.2616px 128.944px 0"
    },
    id: "eluoeorxob9on",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.56 129.31v-.11a4.45 4.45 0 0 1 1.29-.64 3.8 3.8 0 0 1 1.34-.17 4.53 4.53 0 0 1 1.38.22 3 3 0 0 1 1.18.62v.15l-.61-.2-.33-.09a1.77 1.77 0 0 1 .34 1.35c-.16 1-1 .93-1.95.79s-1.67-.32-1.51-1.29a1.84 1.84 0 0 1 .54-1 2.68 2.68 0 0 0-.42.05 11.09 11.09 0 0 0-1.25.32z",
    style: {
      fill: "#263238",
      transformOrigin: "84.155px 129.848px 0"
    },
    id: "elmos3o5fy3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.27 124.54 81 126.77a2 2 0 0 1 .54-2.79 2 2 0 0 1 2.73.56z",
    style: {
      fill: "#263238",
      transformOrigin: "82.4609px 125.218px 0"
    },
    id: "elv84b64d136",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.24 151.92a36.63 36.63 0 0 1-8.9-1.19c-3.45-1.13-5-2.09-6.87-5.88a9.35 9.35 0 0 0 2.8 5.55c4.15 3.5 13 3.44 13 3.44z",
    style: {
      fill: "#f0997a",
      transformOrigin: "82.37px 149.345px 0"
    },
    id: "elxjvvzrnzzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57 119.91c-.55-1 .08-2.8.86-3.46a4.48 4.48 0 0 1 3.6-.6c1.84.54 2.4 2.48 3 4a11 11 0 0 0 1.48 3 5.17 5.17 0 0 0 4.54 2.34 4.76 4.76 0 0 1-1.55-3.93c1.63 1.62 4.63 3.59 7 3.85 1.64.19 2.39-.61 2.65-2.16.69-4.07-1.29-8.77-4.22-11.64a11.66 11.66 0 0 0-1.25-1.08c-6-4.48-15.4-6.19-23-5.25-4.27.52-10.33 4.09-9.56 10.07 3.88-.59 14.62 1.68 16.45 4.86z",
    style: {
      fill: "#37474f",
      transformOrigin: "86.1705px 114.962px 0"
    },
    id: "el4mfao3b7wze",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88 171.15c2.8 6.07 3.7 15.47 3.7 15.47l3.92-.48a67.25 67.25 0 0 0-2.7-12.81 3.45 3.45 0 0 0-3.51-2.25z",
    style: {
      fill: "#37474f",
      transformOrigin: "91.81px 178.845px 0"
    },
    id: "el842hzudyedf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Apron--inject-4",
    style: {
      transformOrigin: "85.59px 225.424px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.46 214c-.86-14.79-1.19-27-4.95-36.73-6.27-16.27-9.78-19.76-9.78-19.76l-4.9-1c6.71 8.55 10.22 25.41 10.22 25.41-6.87 3-16.76 3.55-28.1 3a106.67 106.67 0 0 0-3-12.81 69.89 69.89 0 0 0-5.73-14.43l-3.5 1.39A186.47 186.47 0 0 1 66 181.18c.64 14.22.55 25.52.13 35.28a3.74 3.74 0 0 1-4.54 3.54l-6.06-1.38v4.63l3.09.71a8.44 8.44 0 0 1 6.53 8.88c-.33 4.25-.68 8.33-1 12.4-2.08 26.92-3.28 38.21-3.94 46.08 10.31 6 51.05 2.37 55.44-4.91.01-.05-1.28-56.8-2.19-72.41z",
    style: {
      fill: "#f04e30",
      transformOrigin: "85.59px 225.424px 0"
    },
    id: "el53w8lgs80ul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12 262.24h20.55s.66 22.73.4 25.53-22.14 2.78-22.37-.77 1.42-24.76 1.42-24.76z",
    style: {
      opacity: 0.25,
      transformOrigin: "76.9043px 276.008px 0"
    },
    className: "animable",
    id: "el9vdl3e2zznq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115 258-5.32 1.83s.38 20.42.61 23.95c.07 1.18 2.35.72 5.35-.52-.17-4.76-.4-14.45-.64-25.26z",
    style: {
      opacity: 0.25,
      transformOrigin: "112.66px 271.232px 0"
    },
    className: "animable",
    id: "el4f50kgonpx3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Neck--inject-4",
    style: {
      transformOrigin: "83.565px 165.91px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 173.62a4.63 4.63 0 0 1 2.91-4.26c1.2-.28 6.56 3.81 6.56 3.81s-.55-8.24-5.06-13.23-7.19-6.1-7.19-6.1v3.93a20 20 0 0 1 2.23 6.84c.54 4-1.2 9-1.2 9z",
    style: {
      fill: "#37474f",
      transformOrigin: "96.345px 163.73px 0"
    },
    id: "elynr1z5h118i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24 153.44c-1.69.62-1.79 2.88-6.58 5.29a28.24 28.24 0 0 0 15.21 19.65c2.24-3.22 4.39-7.56 8.12-7.23s5 2.27 5 2.27a4.72 4.72 0 0 0-1.75-2.54c-3.11-2.12-9.2-4.93-12.3-7.1-8.2-5.75-7.65-8.91-7.65-8.91z",
    style: {
      fill: "#455a64",
      transformOrigin: "78.825px 165.91px 0"
    },
    id: "el2rzqu3aaaev",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "78.55px 191.22px 0"
    },
    id: "elmrrbinhi3h",
    className: "animable",
    d: "M70.56 188.77h15.98v4.9H70.56z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4",
    style: {
      transformOrigin: "351.787px 111.649px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4",
    style: {
      transformOrigin: "351.787px 111.649px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4",
    style: {
      transformOrigin: "351.787px 111.649px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.05 92a23.41 23.41 0 0 1 10 14l.49 2.63a23.42 23.42 0 0 1-45.66 9.71l-.62-2.61A23.42 23.42 0 0 1 363.05 92z",
    style: {
      fill: "#fff",
      transformOrigin: "350.317px 111.632px 0"
    },
    id: "elxs8p9z4ttpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 97.8a25.42 25.42 0 0 0 40 31l7.73 1.62a1.48 1.48 0 0 0 1.5-2.31l-4.63-6.41A25.42 25.42 0 0 0 329 97.8zm34.05-5.8a23.41 23.41 0 0 1 10 14l.49 2.63a23.42 23.42 0 0 1-45.66 9.71l-.62-2.61A23.42 23.42 0 0 1 363.05 92z",
    style: {
      fill: "#455a64",
      transformOrigin: "351.787px 111.649px 0"
    },
    id: "el5yyeuy5jc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05 92a23.41 23.41 0 0 1 10 14l.49 2.63a23.42 23.42 0 0 1-45.66 9.71l-.62-2.61A23.42 23.42 0 0 1 363.05 92z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "350.317px 111.632px 0"
    },
    className: "animable",
    id: "elf3fk6bzpov9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-4",
    style: {
      transformOrigin: "350.949px 111.937px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.7 124.19a3.37 3.37 0 0 1-2.46-1.06l-7.65-8.13a3.37 3.37 0 1 1 4.92-4.61l5 5.3 11.75-14.89a3.38 3.38 0 0 1 5.3 4.19l-14.18 18a3.39 3.39 0 0 1-2.51 1.28z",
    style: {
      fill: "#f04e30",
      transformOrigin: "350.949px 111.937px 0"
    },
    id: "elzqmgd5oq7gf",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.c17c123e5724ac9d7a0d372cb4f5909e.svg";
export { ForwardRef as ReactComponent };